const translations = {
  categories: {
    "Channel control": {
      english: "Channel control",
      portuguese: "Controle de canal",
      spanish: "Control de canal",
      spanish_ar: "Control de canal",
      spanish_mx: "Control de canal",
      spanish_cl: "Control de canal",
      spanish_pe: "Control de canal",
      spanish_br: "Control de canal", 
      french: "Contrôle des chaînes",
      german: "Kanalsteuerung",
      italian: "Controllo canale",
      chinese_tw: "頻道控制",
      chinese_cn: "频道控制",
      chinese_sg: "频道控制",
      dutch_be: "Kanaalbediening",
      dutch_nl: "Kanaalbediening"
    },
    "Playback control": {
      english: "Playback control",
      portuguese: "Controle de reprodução",
      spanish: "Control de reproducción",
      spanish_ar: "Control de reproducción",
      spanish_mx: "Control de reproducción",
      spanish_cl: "Control de reproducción",
      spanish_pe: "Control de reproducción",
      spanish_br: "Control de reproducción",
      french: "Contrôle de lecture",
      german: "Wiedergabesteuerung",
      italian: "Controllo riproduzione",
      chinese_tw: "播放控制",
      chinese_cn: "播放控制",
      chinese_sg: "播放控制",
      dutch_be: "Afspeelbediening",
      dutch_nl: "Afspeelbediening"
    },
    "Launch OTT Apps": {
      english: "Launch OTT Apps",
      portuguese: "Iniciar Aplicativos OTT",
      spanish: "Lanzar Aplicaciones OTT",
      spanish_ar: "Lanzar Aplicaciones OTT",
      spanish_mx: "Lanzar Apps OTT",
      spanish_cl: "Lanzar Aplicaciones OTT",
      spanish_pe: "Lanzar Aplicaciones OTT",
      spanish_br: "Lanzar Aplicaciones OTT",
      french: "Lancer Apps OTT",
      german: "OTT-Apps starten",
      italian: "Avvia app OTT",
      chinese_tw: "啟動OTT應用程式",
      chinese_cn: "启动OTT应用程序",
      chinese_sg: "启动OTT应用程序",
      dutch_be: "OTT-apps starten",
      dutch_nl: "OTT-apps starten"
    },
    "Global Search": {
      english: "Global Search",
      portuguese: "Pesquisa Global",
      spanish: "Búsqueda Global",
      spanish_ar: "Búsqueda Global",
      spanish_mx: "Búsqueda Global",
      spanish_cl: "Búsqueda Global",
      spanish_pe: "Búsqueda Global",
      spanish_br: "Búsqueda Global",
      french: "Recherche globale",
      german: "Globale Suche",
      italian: "Ricerca globale",
      chinese_tw: "全局搜索",
      chinese_cn: "全局搜索",
      chinese_sg: "全局搜索",
      dutch_be: "Globaal zoeken",
      dutch_nl: "Globaal zoeken"
    },
    "Weather": {
      english: "Weather",
      portuguese: "Clima",
      spanish: "Clima",
      spanish_ar: "Clima",
      spanish_mx: "Clima",
      spanish_cl: "Clima",
      spanish_pe: "Clima",
      spanish_br: "Clima",
      french: "Météo",
      german: "Wetter",
      italian: "Meteo",
      chinese_tw: "天氣",
      chinese_cn: "天气",
      chinese_sg: "天气",
      dutch_be: "Weer",
      dutch_nl: "Weer"
    },
    "Power on/off": {
      english: "Power on/off",
      portuguese: "Ligar/Desligar",
      spanish: "Encender/Apagar",
      spanish_ar: "Encender/Apagar",
      spanish_mx: "Prender/Apagar",
      spanish_cl: "Encender/Apagar",
      spanish_pe: "Encender/Apagar",
      spanish_br: "Encender/Apagar",
      french: "Allumer/Éteindre",
      german: "Ein/Aus",
      italian: "Accendi/Spegni",
      chinese_tw: "開啟/關閉",
      chinese_cn: "开启/关闭",
      chinese_sg: "开启/关闭",
      dutch_be: "Aan/Uit",
      dutch_nl: "Aan/Uit"
    },
    "Volume control": {
      english: "Volume control",
      portuguese: "Controle de volume",
      spanish: "Control de volumen",
      spanish_ar: "Control de volumen",
      spanish_mx: "Control de volumen",
      spanish_cl: "Control de volumen",
      spanish_pe: "Control de volumen",
      spanish_br: "Control de volumen",
      french: "Contrôle du volume",
      german: "Lautstärkeregelung",
      italian: "Controllo del volume",
      chinese_tw: "音量控制",
      chinese_cn: "音量控制",
      chinese_sg: "音量控制",
      dutch_be: "Volumeregeling",
      dutch_nl: "Volumeregeling"
    },
    "Launch target/shortcut": {
      english: "Launch target/shortcut",
      portuguese: "Iniciar alvo/atalho",
      spanish: "Lanzar objetivo/atajo",
      spanish_ar: "Lanzar objetivo/atajo",
      spanish_mx: "Lanzar objetivo/atajo",
      spanish_cl: "Lanzar objetivo/atajo",
      spanish_pe: "Lanzar objetivo/atajo",
      spanish_br: "Lanzar objetivo/atajo",
      french: "Lancer cible/raccourci",
      german: "Ziel/Verknüpfung öffnen",
      italian: "Avvia obiettivo/scorciatoia",
      chinese_tw: "啟動目標/捷徑",
      chinese_cn: "启动目标/快捷方式",
      chinese_sg: "启动目标/快捷方式",
      dutch_be: "Doel/snelkoppeling starten",
      dutch_nl: "Doel/snelkoppeling starten"
    },
    "Content search": {
      english: "Content search",
      portuguese: "Pesquisa de conteúdo",
      spanish: "Búsqueda de contenido",
      spanish_ar: "Búsqueda de contenido",
      spanish_mx: "Búsqueda de contenido",
      spanish_cl: "Búsqueda de contenido",
      spanish_pe: "Búsqueda de contenido",
      spanish_br: "Búsqueda de contenido",
      french: "Recherche de contenu",
      german: "Inhaltssuche",
      italian: "Ricerca contenuto",
      chinese_tw: "內容搜索",
      chinese_cn: "内容搜索",
      chinese_sg: "内容搜索",
      dutch_be: "Inhoud zoeken",
      dutch_nl: "Inhoud zoeken"
    },
    "Change input source": {
      english: "Change input source",
      portuguese: "Mudar fonte de entrada",
      spanish: "Cambiar fuente de entrada",
      spanish_ar: "Cambiar fuente de entrada",
      spanish_mx: "Cambiar fuente de entrada",
      spanish_cl: "Cambiar fuente de entrada",
      spanish_pe: "Cambiar fuente de entrada",
      spanish_br: "Cambiar fuente de entrada", 
      french: "Changer de source",
      german: "Eingangsquelle wechseln",
      italian: "Cambia sorgente",
      chinese_tw: "更改輸入源",
      chinese_cn: "更改输入源",
      chinese_sg: "更改输入源",
      dutch_be: "Ingangsbron wijzigen",
      dutch_nl: "Ingangsbron wijzigen"
    },
    "Ambilight control": {
      english: "Ambilight control",
      portuguese: "Controle de Ambilight",
      spanish: "Control de Ambilight",
      spanish_ar: "Control de Ambilight",
      spanish_mx: "Control de Ambilight",
      spanish_cl: "Control de Ambilight",
      spanish_pe: "Control de Ambilight",
      spanish_br: "Control de Ambilight", 
      french: "Contrôle Ambilight",
      german: "Ambilight‑Steuerung",
      italian: "Controllo Ambilight",
      chinese_tw: "Ambilight控制",
      chinese_cn: "Ambilight控制",
      chinese_sg: "Ambilight控制",
      dutch_be: "Ambilight-bediening",
      dutch_nl: "Ambilight-bediening"
    },
    "Launch": {
      english: "Launch",
      portuguese: "Iniciar",
      spanish: "Lanzar",
      spanish_ar: "Lanzar",
      spanish_mx: "Lanzar",
      spanish_cl: "Lanzar",
      spanish_pe: "Lanzar",
      spanish_br: "Lanzar", 
      french: "Lancer",
      german: "Starten",
      italian: "Avvia",
      chinese_tw: "啟動",
      chinese_cn: "启动",
      chinese_sg: "启动",
      dutch_be: "Starten",
      dutch_nl: "Starten"
    },
    "IoT voice control": {
      english: "IoT voice control",
      portuguese: "Controle de voz IoT",
      spanish: "Control de voz IoT",
      spanish_ar: "Control de voz IoT",
      spanish_mx: "Control de voz IoT",
      spanish_cl: "Control de voz IoT",
      spanish_pe: "Control de voz IoT",
      spanish_br: "Control de voz IoT",
      french: "Contrôle vocal IoT",
      german: "IoT-Sprachsteuerung",
      italian: "Controllo vocale IoT",
      chinese_tw: "物聯網語音控制",
      chinese_cn: "物联网语音控制",
      chinese_sg: "物联网语音控制",
      dutch_be: "IoT-spraakbesturing",
      dutch_nl: "IoT-spraakbesturing"
    },
  },
  voiceControls: {
    "Turn On": {
      english: "Turn On",
      portuguese: "Ligar",
      spanish: "Encender",
      spanish_ar: "Encender",
      spanish_mx: "Prender",
      spanish_cl: "Encender",
      spanish_pe: "Encender",
      spanish_br: "Encender", 
      french: "Allumer",
      german: "Einschalten",
      italian: "Accendere",
      chinese_tw: "開啟",
      chinese_cn: "开启",
      chinese_sg: "开启",
      dutch_be: "Aanzetten",
      dutch_nl: "Aanzetten"
    },
    "Turn Off": {
      english: "Turn Off",
      portuguese: "Desligar",
      spanish: "Apagar",
      spanish_ar: "Apagar",
      spanish_mx: "Apagar",
      spanish_cl: "Apagar",
      spanish_pe: "Apagar",
      spanish_br: "Apagar", 
      french: "Éteindre",
      german: "Ausschalten",
      italian: "Spegnere",
      chinese_tw: "關閉",
      chinese_cn: "关闭",
      chinese_sg: "关闭",
      dutch_be: "Uitzetten",
      dutch_nl: "Uitzetten"
    },
    "Volume Up": {
      english: "Volume Up",
      portuguese: "Aumentar Volume",
      spanish: "Subir Volumen",
      spanish_ar: "Subir Volumen",
      spanish_mx: "Subir Volumen",
      spanish_cl: "Subir Volumen",
      spanish_pe: "Subir Volumen",
      spanish_br: "Subir Volumen", 
      french: "Augmenter le volume",
      german: "Lauter",
      italian: "Alza volume",
      chinese_tw: "音量調高",
      chinese_cn: "音量调高",
      chinese_sg: "音量调高",
      dutch_be: "Volume hoger",
      dutch_nl: "Volume hoger"
    },
    "Volume Down": {
      english: "Volume Down",
      portuguese: "Diminuir Volume",
      spanish: "Bajar Volumen",
      spanish_ar: "Bajar Volumen",
      spanish_mx: "Bajar Volumen",
      spanish_cl: "Bajar Volumen",
      spanish_pe: "Bajar Volumen",
      spanish_br: "Bajar Volumen", 
      french: "Diminuer le volume",
      german: "Leiser",
      italian: "Abbassa volume",
      chinese_tw: "音量調低",
      chinese_cn: "音量调低",
      chinese_sg: "音量调低",
      dutch_be: "Volume lager",
      dutch_nl: "Volume lager"
    },
    "Set Volume Level": {
      english: "Set Volume Level",
      portuguese: "Definir Nível de Volume",
      spanish: "Ajustar Nivel de Volumen",
      spanish_ar: "Ajustar Nivel de Volumen",
      spanish_mx: "Ajustar Nivel de Volumen",
      spanish_cl: "Ajustar Nivel de Volumen",
      spanish_pe: "Ajustar Nivel de Volumen",
      spanish_br: "Ajustar Nivel de Volumen", 
      french: "Régler le volume",
      german: "Lautstärke einstellen",
      italian: "Imposta livello volume",
      chinese_tw: "設定音量等級",
      chinese_cn: "设置音量级别",
      chinese_sg: "设置音量级别",
      dutch_be: "Volume instellen",
      dutch_nl: "Volume instellen"
    },
    "Numbers 0-60": {
      english: "Numbers 0-60",
      portuguese: "Números 0-60",
      spanish: "Números 0-60",
      spanish_ar: "Números 0-60",
      spanish_mx: "Números 0-60",
      spanish_cl: "Números 0-60",
      spanish_pe: "Números 0-60",
      spanish_br: "Números 0-60", 
      french: "Nombres 0–60",
      german: "Zahlen 0–60",
      italian: "Numeri 0–60",
      chinese_tw: "數字0-60",
      chinese_cn: "数字0-60",
      chinese_sg: "数字0-60",
      dutch_be: "Nummers 0-60",
      dutch_nl: "Nummers 0-60"
    },
    Mute: {
      english: "Mute",
      portuguese: "Silenciar",
      spanish: "Silenciar",
      spanish_ar: "Silenciar",
      spanish_mx: "Silenciar",
      spanish_cl: "Silenciar",
      spanish_pe: "Silenciar",
      spanish_br: "Silenciar", 
      french: "Muet",
      german: "Stummschalten",
      italian: "Muto",
      chinese_tw: "靜音",
      chinese_cn: "静音",
      chinese_sg: "静音",
      dutch_be: "Dempen",
      dutch_nl: "Dempen"
    },
    Unmute: {
      english: "Unmute",
      portuguese: "Desmutar",
      spanish: "Desactivar Silencio",
      spanish_ar: "Desactivar Silencio",
      spanish_mx: "Quitar Silencio",
      spanish_cl: "Desactivar Silencio",
      spanish_pe: "Quitar Silencio",
      spanish_br: "Desactivar Silencio", 
      french: "Réactiver son",
      german: "Stummschaltung aufheben",
      italian: "Disattiva muto",
      chinese_tw: "取消靜音",
      chinese_cn: "取消静音",
      chinese_sg: "取消静音",
      dutch_be: "Dempen opheffen",
      dutch_nl: "Dempen opheffen"
    },
    "Open OTT Apps (YouTube, Netflix, Amazon Prime, etc)": {
      english: "Open OTT Apps (YouTube, Netflix, Amazon Prime, etc)",
      portuguese: "Abrir Aplicativos OTT (YouTube, Netflix, Amazon Prime, etc)",
      spanish: "Abrir Aplicaciones OTT (YouTube, Netflix, Amazon Prime, etc)",
      spanish_ar: "Abrir Aplicaciones OTT (YouTube, Netflix, Amazon Prime, etc)",
      spanish_mx: "Abrir Apps OTT (YouTube, Netflix, Amazon Prime, etc)",
      spanish_cl: "Abrir Aplicaciones OTT (YouTube, Netflix, Amazon Prime, etc)",
      spanish_pe: "Abrir Aplicaciones OTT (YouTube, Netflix, Amazon Prime, etc)",
      spanish_br: "Abrir Aplicaciones OTT (YouTube, Netflix, Amazon Prime, etc)", 
      french: "Ouvrir Apps OTT (YouTube, Netflix…)",
      german: "OTT‑Apps öffnen (YouTube, Netflix…)",
      italian: "Apri app OTT (YouTube, Netflix…)",
      chinese_tw: "開啟OTT應用程式（YouTube、Netflix、Amazon Prime等）",
      chinese_cn: "打开OTT应用程序（YouTube、Netflix、Amazon Prime等）",
      chinese_sg: "打开OTT应用程序（YouTube、Netflix、Amazon Prime等）",
      dutch_be: "OTT-apps openen (YouTube, Netflix, Amazon Prime, enz.)",
      dutch_nl: "OTT-apps openen (YouTube, Netflix, Amazon Prime, enz.)"
    },
    "Go Home": {
      english: "Go Home",
      portuguese: "Ir para Casa",
      spanish: "Ir a Casa",
      spanish_ar: "Ir a Casa",
      spanish_mx: "Ir a Inicio",
      spanish_cl: "Ir a Inicio",
      spanish_pe: "Ir a Inicio",
      spanish_br: "Ir a Inicio", 
      french: "Aller à l'accueil",
      german: "Zum Startbildschirm",
      italian: "Vai home",
      chinese_tw: "返回主頁",
      chinese_cn: "返回主页",
      chinese_sg: "返回主页",
      dutch_be: "Naar Home",
      dutch_nl: "Naar Home"
    },
    "Go to settings": {
      english: "Go to settings",
      portuguese: "Ir para configurações",
      spanish: "Ir a configuraciones",
      spanish_ar: "Ir a configuraciones",
      spanish_mx: "Ir a ajustes",
      spanish_cl: "Ir a configuraciones",
      spanish_pe: "Ir a configuraciones",
      spanish_br: "Ir a configuraciones",
      french: "Aller aux paramètres",
      german: "Zu Einstellungen gehen",
      italian: "Vai alle impostazioni",
      chinese_tw: "前往設定",
      chinese_cn: "转到设置",
      chinese_sg: "转到设置",
      dutch_be: " Ga naar instellingen",
      dutch_nl: "Ga naar instellingen"
    },
    "Global Search and Display (Launcher)": {
      english: "Global Search and Display (Launcher)",
      portuguese: "Pesquisa Global e Exibição (Launcher)",
      spanish: "Búsqueda Global y Visualización (Launcher)",
      spanish_ar: "Búsqueda Global y Visualización (Launcher)",
      spanish_mx: "Búsqueda Global y Visualización (Launcher)",
      spanish_cl: "Búsqueda Global y Visualización (Launcher)",
      spanish_pe: "Búsqueda Global y Visualización (Launcher)",
      spanish_br: "Búsqueda Global y Visualización (Launcher)", 
      french: "Recherche globale (Launcher)",
      german: "Globale Suche (Launcher)",
      italian: "Ricerca globale (Launcher)",
      chinese_tw: "全局搜索與顯示（啟動器）",
      chinese_cn: "全局搜索与显示（启动器）",
      chinese_sg: "全局搜索与显示（启动器）",
      dutch_be: "Globaal zoeken en weergeven (Launcher)",
      dutch_nl: "Globaal zoeken en weergeven (Launcher)"
    },
    "YouTube search (certification)": {
      english: "YouTube search (certification)",
      portuguese: "Pesquisa no YouTube (certificação)",
      spanish: "Búsqueda en YouTube (certificación)",
      spanish_ar: "Búsqueda en YouTube (certificación)",
      spanish_mx: "Búsqueda en YouTube (certificación)",
      spanish_cl: "Búsqueda en YouTube (certificación)",
      spanish_pe: "Búsqueda en YouTube (certificación)",
      spanish_br: "Búsqueda en YouTube (certificación)", 
      french: "Recherche YouTube (certif.)",
      german: "YouTube‑Suche (Zert.)",
      italian: "Ricerca YouTube (cert.)",
      chinese_tw: "YouTube搜索（認證）",
      chinese_cn: "YouTube搜索（认证）",
      chinese_sg: "YouTube搜索（认证）",
      dutch_be: "YouTube zoeken (certificering)",
      dutch_nl: "YouTube zoeken (certificering)"
    },
      "Switch to USB": {
        english: "Switch to USB",
        portuguese: "Mudar para USB",
        spanish: "Cambiar a USB",
        spanish_ar: "Cambiar a USB",
        spanish_mx: "Cambiar a USB",
        spanish_cl: "Cambiar a USB",
        spanish_pe: "Cambiar a USB",
        spanish_br: "Mudar para USB",
        french: "Basculer sur USB",
        german: "Wechsle zu USB",
        italian: "Passa a USB",
        chinese_tw: "切換到USB",
        chinese_cn: "切换到USB",
        chinese_sg: "切换到USB",
        dutch_be: "Schakel over naar USB",
        dutch_nl: "Schakel over naar USB"
      },
      "Switch to HDMI 1": {
        english: "Switch to HDMI 1",
        portuguese: "Mudar para HDMI 1",
        spanish: "Cambiar a HDMI 1",
        spanish_ar: "Cambiar a HDMI 1",
        spanish_mx: "Cambiar a HDMI 1",
        spanish_cl: "Cambiar a HDMI 1",
        spanish_pe: "Cambiar a HDMI 1",
        spanish_br: "Mudar para HDMI 1",
        french: "Basculer sur HDMI 1",
        german: "Schalte auf HDMI 1",
        italian: "Passa a HDMI 1",
        chinese_tw: "切換到HDMI 1",
        chinese_cn: "切换到HDMI 1",
        chinese_sg: "切换到HDMI 1",
        dutch_be: "Schakel naar HDMI 1",
        dutch_nl: "Schakel naar HDMI 1"
      },
    "Resume TV": {
      english: "Resume TV",
      portuguese: "Retomar TV",
      spanish: "Reanudar TV",
      spanish_ar: "Reanudar TV",
      spanish_mx: "Reanudar TV",
      spanish_cl: "Reanudar TV",
      spanish_pe: "Reanudar TV",
      spanish_br: "Retomar TV",
      french: "Reprendre la TV",
      german: "Fernsehen fortsetzen",
      italian: "Riprendi TV",
      chinese_tw: "繼續播放電視",
      chinese_cn: "继续播放电视",
      chinese_sg: "继续播放电视",
      dutch_be: "Hervat TV",
      dutch_nl: "Hervat TV"
    },
    "Stop": {
      english: "Stop",
      portuguese: "Parar",
      spanish: "Detener",
      spanish_ar: "Detener",
      spanish_mx: "Detener",
      spanish_cl: "Detener",
      spanish_pe: "Detener",
      spanish_br: "Parar",
      french: "Arrêter",
      german: "Stopp",
      italian: "Ferma",
      chinese_tw: "停止",
      chinese_cn: "停止",
      chinese_sg: "停止",
      dutch_be: "Stop",
      dutch_nl: "Stop"
    },
    "Pause": {
      english: "Pause",
      portuguese: "Pausar",
      spanish: "Pausar",
      spanish_ar: "Pausar",
      spanish_mx: "Pausar",
      spanish_cl: "Pausar",
      spanish_pe: "Pausar",
      spanish_br: "Pausar",
      french: "Pause",
      german: "Pause",
      italian: "Pausa",
      chinese_tw: "暫停",
      chinese_cn: "暂停",
      chinese_sg: "暂停",
      dutch_be: "Pauzeren",
      dutch_nl: "Pauzeren"
    },
    "Play TV": {
      english: "Play TV",
      portuguese: "Reproduzir TV",
      spanish: "Reproducir TV",
      spanish_ar: "Reproducir TV",
      spanish_mx: "Reproducir TV",
      spanish_cl: "Reproducir TV",
      spanish_pe: "Reproducir TV",
      spanish_br: "Reproduzir TV",
      french: "Lire la TV",
      german: "Fernsehen abspielen",
      italian: "Riproduci TV",
      chinese_tw: "播放電視",
      chinese_cn: "播放电视",
      chinese_sg: "播放电视",
      dutch_be: "TV afspelen",
      dutch_nl: "TV afspelen"
    },
    "Next": {
      english: "Next",
      portuguese: "Próximo",
      spanish: "Siguiente",
      spanish_ar: "Siguiente",
      spanish_mx: "Siguiente",
      spanish_cl: "Siguiente",
      spanish_pe: "Siguiente",
      spanish_br: "Próximo",
      french: "Suivant",
      german: "Weiter",
      italian: "Successivo",
      chinese_tw: "下一個",
      chinese_cn: "下一个",
      chinese_sg: "下一个",
      dutch_be: "Volgende",
      dutch_nl: "Volgende"
    },
    "Previous": {
      english: "Previous",
      portuguese: "Anterior",
      spanish: "Anterior",
      spanish_ar: "Anterior",
      spanish_mx: "Anterior",
      spanish_cl: "Anterior",
      spanish_pe: "Anterior",
      spanish_br: "Anterior",
      french: "Précédent",
      german: "Zurück",
      italian: "Precedente",
      chinese_tw: "上一個",
      chinese_cn: "上一个",
      chinese_sg: "上一个",
      dutch_be: "Vorige",
      dutch_nl: "Vorige"
    },
    "Turn On/Off Ambilight": {
      english: "Turn On/Off Ambilight",
      portuguese: "Ligar/Desligar Ambilight",
      spanish: "Encender/Apagar Ambilight",
      spanish_ar: "Encender/Apagar Ambilight",
      spanish_mx: "Prender/Apagar Ambilight",
      spanish_cl: "Encender/Apagar Ambilight",
      spanish_pe: "Encender/Apagar Ambilight",
      spanish_br: "Encender/Apagar Ambilight", 
      french: "Allumer/Éteindre Ambilight",
      german: "Ambilight ein/aus",
      italian: "Accendi/Spegni Ambilight",
      chinese_tw: "開啟/關閉Ambilight",
      chinese_cn: "开启/关闭Ambilight",
      chinese_sg: "开启/关闭Ambilight",
      dutch_be: "Ambilight aan/uit",
      dutch_nl: "Ambilight aan/uit"
    },
    "Go to info": {
      english: "Go to info",
      portuguese: "Ir para informações",
      spanish: "Ir a información",
      spanish_ar: "Ir a información",
      spanish_mx: "Ir a información",
      spanish_cl: "Ir a información",
      spanish_pe: "Ir a información",
      spanish_br: "Ir a información", 
      french: "Aller à l'info",
      german: "Zu Infos",
      italian: "Vai a info",
      chinese_tw: "前往資訊",
      chinese_cn: "前往信息",
      chinese_sg: "前往信息",
      dutch_be: "Naar info",
      dutch_nl: "Naar info"
    },
    "Launch TV guide": {
      english: "Launch TV guide",
      portuguese: "Abrir guia de TV",
      spanish: "Abrir guía de TV",
      spanish_ar: "Abrir guía de TV",
      spanish_mx: "Abrir guía de TV",
      spanish_cl: "Abrir guía de TV",
      spanish_pe: "Abrir guía de TV",
      spanish_br: "Abrir guía de TV", 
      french: "Ouvrir le guide TV",
      german: "TV-Guide öffnen",
      italian: "Apri guida TV",
      chinese_tw: "啟動電視節目表",
      chinese_cn: "启动电视节目表",
      chinese_sg: "启动电视节目表",
      dutch_be: "TV-gids openen",
      dutch_nl: "TV-gids openen"
    },
    "Launch info": {
      english: "Launch info",
      portuguese: "Abrir informações",
      spanish: "Abrir información",
      spanish_ar: "Abrir información",
      spanish_mx: "Abrir información",
      spanish_cl: "Abrir información",
      spanish_pe: "Abrir información",
      spanish_br: "Abrir información", 
      french: "Lancer l'info",
      german: "Info öffnen",
      italian: "Avvia info",
      chinese_tw: "啟動資訊",
      chinese_cn: "启动信息",
      chinese_sg: "启动信息",
      dutch_be: "Info openen",
      dutch_nl: "Info openen"
    },
    "Go to inputs": {
      english: "Go to inputs",
      portuguese: "Ir para entradas",
      spanish: "Ir a entradas",
      spanish_ar: "Ir a entradas",
      spanish_mx: "Ir a entradas",
      spanish_cl: "Ir a entradas",
      spanish_pe: "Ir a entradas",
      spanish_br: "Ir a entradas", 
      french: "Aller aux entrées",
      german: "Zu Eingängen",
      italian: "Vai a ingressi",
      chinese_tw: "前往輸入",
      chinese_cn: "前往输入",
      chinese_sg: "前往输入",
      dutch_be: "Naar ingangen",
      dutch_nl: "Naar ingangen"
    },
    "Launch YouTube": {
      english: "Launch YouTube",
      portuguese: "Iniciar YouTube",
      spanish: "Lanzar YouTube",
      spanish_ar: "Lanzar YouTube",
      spanish_mx: "Lanzar YouTube",
      spanish_cl: "Lanzar YouTube",
      spanish_pe: "Lanzar YouTube",
      spanish_br: "Lanzar YouTube",
      french: "Lancer YouTube",
      german: "YouTube starten",
      italian: "Avvia YouTube",
      chinese_tw: "啟動YouTube",
      chinese_cn: "启动YouTube",
      chinese_sg: "启动YouTube",
      dutch_be: "YouTube starten",
      dutch_nl: "YouTube starten"
    },
    "Open YouTube": {
      english: "Open YouTube",
      portuguese: "Abrir YouTube",
      spanish: "Abrir YouTube",
      spanish_ar: "Abrir YouTube",
      spanish_mx: "Abrir YouTube",
      spanish_cl: "Abrir YouTube",
      spanish_pe: "Abrir YouTube",
      spanish_br: "Abrir YouTube",
      french: "Ouvrir YouTube",
      german: "YouTube öffnen",
      italian: "Apri YouTube",
      chinese_tw: "開啟YouTube",
      chinese_cn: "打开YouTube",
      chinese_sg: "打开YouTube",
      dutch_be: "YouTube openen",
      dutch_nl: "YouTube openen"
    },
    "YouTube": {
      english: "YouTube",
      portuguese: "YouTube",
      spanish: "YouTube",
      spanish_ar: "YouTube",
      spanish_mx: "YouTube",
      spanish_cl: "YouTube",
      spanish_pe: "YouTube",
      spanish_br: "YouTube",
      french: "YouTube",
      german: "YouTube",
      italian: "YouTube",
      chinese_tw: "YouTube",
      chinese_cn: "YouTube",
      chinese_sg: "YouTube",
      dutch_be: "YouTube",
      dutch_nl: "YouTube"
    },
    "Launch Netflix": {
      english: "Launch Netflix",
      portuguese: "Iniciar Netflix",
      spanish: "Lanzar Netflix",
      spanish_ar: "Lanzar Netflix",
      spanish_mx: "Lanzar Netflix",
      spanish_cl: "Lanzar Netflix",
      spanish_pe: "Lanzar Netflix",
      spanish_br: "Lanzar Netflix",
      french: "Lancer Netflix",
      german: "Netflix starten",
      italian: "Avvia Netflix",
      chinese_tw: "啟動Netflix",
      chinese_cn: "启动Netflix",
      chinese_sg: "启动Netflix",
      dutch_be: "Netflix starten",
      dutch_nl: "Netflix starten"
    },
    "Open Netflix": {
      english: "Open Netflix",
      portuguese: "Abrir Netflix",
      spanish: "Abrir Netflix",
      spanish_ar: "Abrir Netflix",
      spanish_mx: "Abrir Netflix",
      spanish_cl: "Abrir Netflix",
      spanish_pe: "Abrir Netflix",
      spanish_br: "Abrir Netflix",
      french: "Ouvrir Netflix",
      german: "Netflix öffnen",
      italian: "Apri Netflix",
      chinese_tw: "開啟Netflix",
      chinese_cn: "打开Netflix",
      chinese_sg: "打开Netflix",
      dutch_be: "Netflix openen",
      dutch_nl: "Netflix openen"
    },
    "Netflix": {
      english: "Netflix",
      portuguese: "Netflix",
      spanish: "Netflix",
      spanish_ar: "Netflix",
      spanish_mx: "Netflix",
      spanish_cl: "Netflix",
      spanish_pe: "Netflix",
      spanish_br: "Netflix",
      french: "Netflix",
      german: "Netflix",
      italian: "Netflix",
      chinese_tw: "Netflix",
      chinese_cn: "Netflix",
      chinese_sg: "Netflix",
      dutch_be: "Netflix",
      dutch_nl: "Netflix"
    },
    "Launch Prime Video": {
      english: "Launch Prime Video",
      portuguese: "Iniciar Prime Video",
      spanish: "Lanzar Prime Video",
      spanish_ar: "Lanzar Prime Video",
      spanish_mx: "Lanzar Prime Video",
      spanish_cl: "Lanzar Prime Video",
      spanish_pe: "Lanzar Prime Video",
      spanish_br: "Lanzar Prime Video",
      french: "Lancer Prime Video",
      german: "Prime Video starten",
      italian: "Avvia Prime Video",
      chinese_tw: "啟動Prime Video",
      chinese_cn: "启动Prime Video",
      chinese_sg: "启动Prime Video",
      dutch_be: "Prime Video starten",
      dutch_nl: "Prime Video starten"
    },
    "Open Prime Video": {
      english: "Open Prime Video",
      portuguese: "Abrir Prime Video",
      spanish: "Abrir Prime Video",
      spanish_ar: "Abrir Prime Video",
      spanish_mx: "Abrir Prime Video",
      spanish_cl: "Abrir Prime Video",
      spanish_pe: "Abrir Prime Video",
      spanish_br: "Abrir Prime Video",
      french: "Ouvrir Prime Video",
      german: "Prime Video öffnen",
      italian: "Apri Prime Video",
      chinese_tw: "開啟Prime Video",
      chinese_cn: "打开Prime Video",
      chinese_sg: "打开Prime Video",
      dutch_be: "Prime Video openen",
      dutch_nl: "Prime Video openen"
    },
    "Prime Video": {
      english: "Prime Video",
      portuguese: "Prime Video",
      spanish: "Prime Video",
      spanish_ar: "Prime Video",
      spanish_mx: "Prime Video",
      spanish_cl: "Prime Video",
      spanish_pe: "Prime Video",
      spanish_br: "Prime Video",
      french: "Prime Video",
      german: "Prime Video",
      italian: "Prime Video",
      chinese_tw: "Prime Video",
      chinese_cn: "Prime Video",
      chinese_sg: "Prime Video",
      dutch_be: "Prime Video",
      dutch_nl: "Prime Video"
    },
    "Search for Spiderman movie": {
      english: "Search for Spiderman movie",
      portuguese: "Pesquisar filme do Homem-Aranha",
      spanish: "Buscar película de Spider-Man",
      spanish_ar: "Buscar película de Spider-Man",
      spanish_mx: "Buscar película de Spider-Man",
      spanish_cl: "Buscar película de Spider-Man",
      spanish_pe: "Buscar película de Spider-Man",
      spanish_br: "Buscar película de Spider-Man",
      french: "Rechercher le film Spider-Man",
      german: "Nach Spider-Man-Film suchen",
      italian: "Cerca film Spider-Man",
      chinese_tw: "搜索蜘蛛人電影",
      chinese_cn: "搜索蜘蛛侠电影",
      chinese_sg: "搜索蜘蛛侠电影",
      dutch_be: "Zoek naar Spider-Man film",
      dutch_nl: "Zoek naar Spider-Man film"
    },
    "Search for Spiderman movie on YouTube": {
      english: "Search for Spiderman movie on YouTube",
      portuguese: "Pesquisar filme do Homem-Aranha no YouTube",
      spanish: "Buscar película de Spider-Man en YouTube",
      spanish_ar: "Buscar película de Spider-Man en YouTube",
      spanish_mx: "Buscar película de Spider-Man en YouTube",
      spanish_cl: "Buscar película de Spider-Man en YouTube",
      spanish_pe: "Buscar película de Spider-Man en YouTube",
      spanish_br: "Buscar película de Spider-Man en YouTube",
      french: "Rechercher le film Spider-Man sur YouTube",
      german: "Spider-Man-Film auf YouTube suchen",
      italian: "Cerca film Spider-Man su YouTube",
      chinese_tw: "在YouTube上搜索蜘蛛人電影",
      chinese_cn: "在YouTube上搜索蜘蛛侠电影",
      chinese_sg: "在YouTube上搜索蜘蛛侠电影",
      dutch_be: "Zoek naar Spider-Man film op YouTube",
      dutch_nl: "Zoek naar Spider-Man film op YouTube"
    },
    "General Weather Inquiries": {
      english: "General Weather Inquiries",
      portuguese: "Consultas Gerais sobre o Clima",
      spanish: "Consultas Generales sobre el Clima",
      spanish_ar: "Consultas Generales sobre el Clima",
      spanish_mx: "Consultas Generales sobre el Clima",
      spanish_cl: "Consultas Generales sobre el Clima",
      spanish_pe: "Consultas Generales sobre el Clima",
      spanish_br: "Consultas Generales sobre el Clima",
      french: "Demandes Générales sur la Météo",
      german: "Allgemeine Wetteranfragen",
      italian: "Richieste Generali sul Meteo",
      chinese_tw: "一般天氣查詢",
      chinese_cn: "一般天气查询",
      chinese_sg: "一般天气查询",
      dutch_be: "Algemene Weervragen",
      dutch_nl: "Algemene Weervragen"
    },
    // "Location-Specific Queries": {
    //   english: "Location-Specific Queries",
    //   portuguese: "Consultas Específicas por Localização",
    //   spanish: "Consultas Específicas por Ubicación",
    //   spanish_ar: "Consultas Específicas por Ubicación",
    //   spanish_mx: "Consultas Específicas por Ubicación",
    //   spanish_cl: "Consultas Específicas por Ubicación",
    //   spanish_pe: "Consultas Específicas por Ubicación",
    //   spanish_br: "Consultas Específicas por Ubicación",
    //   french: "Demandes Spécifiques à un Lieu",
    //   german: "Ortsspezifische Anfragen",
    //   italian: "Richieste Specifiche per Località",
    //   chinese_tw: "特定地點查詢",
    //   chinese_cn: "特定地点查询",
    //   chinese_sg: "特定地点查询",
    //   dutch_be: "Locatiespecifieke Vragen",
    //   dutch_nl: "Locatiespecifieke Vragen"
    // },
    "Forecast & Planning Questions": {
      english: "Forecast & Planning Questions",
      portuguese: "Perguntas sobre Previsão e Planejamento",
      spanish: "Preguntas sobre Pronóstico y Planificación",
      spanish_ar: "Preguntas sobre Pronóstico y Planificación",
      spanish_mx: "Preguntas sobre Pronóstico y Planificación",
      spanish_cl: "Preguntas sobre Pronóstico y Planificación",
      spanish_pe: "Preguntas sobre Pronóstico y Planificación",
      spanish_br: "Preguntas sobre Pronóstico y Planificación",
      french: "Questions sur les Prévisions et la Planification",
      german: "Fragen zu Vorhersagen und Planung",
      italian: "Domande su Previsioni e Pianificazione",
      chinese_tw: "預報與計劃問題",
      chinese_cn: "预报与计划问题",
      chinese_sg: "预报与计划问题",
      dutch_be: "Vragen over Voorspellingen en Planning",
      dutch_nl: "Vragen over Voorspellingen en Planning"
    },
    "Specific Conditions": {
      english: "Specific Conditions",
      portuguese: "Condições Específicas",
      spanish: "Condiciones Específicas",
      spanish_ar: "Condiciones Específicas",
      spanish_mx: "Condiciones Específicas",
      spanish_cl: "Condiciones Específicas",
      spanish_pe: "Condiciones Específicas",
      spanish_br: "Condiciones Específicas",
      french: "Conditions Spécifiques",
      german: "Spezifische Bedingungen",
      italian: "Condizioni Specifiche",
      chinese_tw: "特定條件",
      chinese_cn: "特定条件",
      chinese_sg: "特定条件",
      dutch_be: "Specifieke Omstandigheden",
      dutch_nl: "Specifieke Omstandigheden"
    }
  }
};

const tvControlData = {
  "IoT voice control": {
    "Turn On": {
      english: ["turn on", "power on", "switch on", "start it", "activate", "turn the device on", "enable it", "light it up"],
      portuguese: ["Ligar"],
      spanish: ["Encender"],
      spanish_ar: ["Encender"],
      spanish_mx: ["Prender"],
      spanish_cl: ["Encender"],
      spanish_pe: ["Encender"],
      spanish_br: ["Encender"],
      french: ["Allumer"],
      german: ["Einschalten"],
      italian: ["Accendere"],
      chinese_tw: ["開啟"],
      chinese_cn: ["开启"],
      chinese_sg: ["开启"],
      dutch_be: ["Aanzetten"],
      dutch_nl: ["Aanzetten"]
    },
    "Turn Off": {
      english: ["turn off", "power off", "switch off", "shut it off", "deactivate", "stop the device", "turn the device off"],
      portuguese: ["Desligar"],
      spanish: ["Apagar"],
      spanish_ar: ["Apagar"],
      spanish_mx: ["Apagar"],
      spanish_cl: ["Apagar"],
      spanish_pe: ["Apagar"],
      spanish_br: ["Apagar"],
      french: ["Éteindre"],
      german: ["Ausschalten"],
      italian: ["Spegnere"],
      chinese_tw: ["關閉"],
      chinese_cn: ["关闭"],
      chinese_sg: ["关闭"],
      dutch_be: ["Uitzetten"],
      dutch_nl: ["Uitzetten"]
    },
    "Brighter": {
      english: ["make it brighter", "increase brightness", "too dark", "brighten the light", "raise the brightness"],
      portuguese: ["Mais brilho", "Deixar mais brilhante"],
      spanish: ["Más brillante", "Hazlo más brillante"],
      spanish_ar: ["Más brillante", "Hazlo más brillante"],
      spanish_mx: ["Más brillante", "Hazlo más brillante"],
      spanish_cl: ["Más brillante", "Hazlo más brillante"],
      spanish_pe: ["Más brillante", "Hazlo más brillante"],
      spanish_br: ["Mais brilho", "Deixar mais brilhante"],
      french: ["Plus brillant", "Rends-le plus brillant"],
      german: ["Heller", "Mach es heller"],
      italian: ["Più luminoso", "Rendilo più luminoso"],
      chinese_tw: ["更亮", "讓它更亮"],
      chinese_cn: ["更亮", "让它更亮"],
      chinese_sg: ["更亮", "让它更亮"],
      dutch_be: ["Helderder", "Maak het helderder"],
      dutch_nl: ["Helderder", "Maak het helderder"]
    },
    "Dimmer, less brighter": {
      english: ["make it dimmer", "reduce brightness", "too bright", "lower the brightness", "dim the light"],
      portuguese: ["Mais escuro", "Menos brilho", "Escurecer"],
      spanish: ["Más oscuro", "Menos brillante", "Oscurecer"],
      spanish_ar: ["Más oscuro", "Menos brillante", "Oscurecer"],
      spanish_mx: ["Más oscuro", "Menos brillante", "Oscurecer"],
      spanish_cl: ["Más oscuro", "Menos brillante", "Oscurecer"],
      spanish_pe: ["Más oscuro", "Menos brillante", "Oscurecer"],
      spanish_br: ["Mais escuro", "Menos brilho", "Escurecer"],
      french: ["Plus sombre", "Moins brillant", "Assombrir"],
      german: ["Dunkler", "Weniger hell", "Abdunkeln"],
      italian: ["Più scuro", "Meno luminoso", "Oscurare"],
      chinese_tw: ["更暗", "較不亮", "變暗"],
      chinese_cn: ["更暗", "较不亮", "变暗"],
      chinese_sg: ["更暗", "较不亮", "变暗"],
      dutch_be: ["Donkerder", "Minder helder", "Dimmen"],
      dutch_nl: ["Donkerder", "Minder helder", "Dimmen"]
    },
    "Warmer": {
      english: ["make it warmer", "warmer light", "increase warmth", "yellowish light", "add warmth"],
      portuguese: ["Mais quente"],
      spanish: ["Más cálido"],
      spanish_ar: ["Más cálido"],
      spanish_mx: ["Más cálido"],
      spanish_cl: ["Más cálido"],
      spanish_pe: ["Más cálido"],
      spanish_br: ["Mais quente"],
      french: ["Plus chaud"],
      german: ["Wärmer"],
      italian: ["Più caldo"],
      chinese_tw: ["更溫暖"],
      chinese_cn: ["更温暖"],
      chinese_sg: ["更温暖"],
      dutch_be: ["Warmer"],
      dutch_nl: ["Warmer"]
    },
    "Softer": {
      english: ["softer light", "reduce harshness", "smoothen light"],
      portuguese: ["Mais suave"],
      spanish: ["Más suave"],
      spanish_ar: ["Más suave"],
      spanish_mx: ["Más suave"],
      spanish_cl: ["Más suave"],
      spanish_pe: ["Más suave"],
      spanish_br: ["Mais suave"],
      french: ["Plus doux"],
      german: ["Weicher"],
      italian: ["Più morbido"],
      chinese_tw: ["更柔和"],
      chinese_cn: ["更柔和"],
      chinese_sg: ["更柔和"],
      dutch_be: ["Zachter"],
      dutch_nl: ["Zachter"]
    },
    "Cooler": {
      english: ["make it cooler", "cooler light", "bluer light", "decrease warmth"],
      portuguese: ["Mais frio"],
      spanish: ["Más frío"],
      spanish_ar: ["Más frío"],
      spanish_mx: ["Más frío"],
      spanish_cl: ["Más frío"],
      spanish_pe: ["Más frío"],
      spanish_br: ["Mais frio"],
      french: ["Plus froid"],
      german: ["Kälter"],
      italian: ["Più freddo"],
      chinese_tw: ["更涼爽"],
      chinese_cn: ["更凉爽"],
      chinese_sg: ["更凉爽"],
      dutch_be: ["Koeler"],
      dutch_nl: ["Koeler"]
    },
    "Common colors": {
      english: ["set it to red", "turn blue", "make it green", "change color to purple", "change the light color"],
      portuguese: ["Vermelho", "Azul", "Verde", "Amarelo", "Branco"],
      spanish: ["Rojo", "Azul", "Verde", "Amarillo", "Blanco"],
      spanish_ar: ["Rojo", "Azul", "Verde", "Amarillo", "Blanco"],
      spanish_mx: ["Rojo", "Azul", "Verde", "Amarillo", "Blanco"],
      spanish_cl: ["Rojo", "Azul", "Verde", "Amarillo", "Blanco"],
      spanish_pe: ["Rojo", "Azul", "Verde", "Amarillo", "Blanco"],
      spanish_br: ["Vermelho", "Azul", "Verde", "Amarelo", "Branco"],
      french: ["Rouge", "Bleu", "Vert", "Jaune", "Blanc"],
      german: ["Rot", "Blau", "Grün", "Gelb", "Weiß"],
      italian: ["Rosso", "Blu", "Verde", "Giallo", "Bianco"],
      chinese_tw: ["紅色", "藍色", "綠色", "黃色", "白色"],
      chinese_cn: ["红色", "蓝色", "绿色", "黄色", "白色"],
      chinese_sg: ["红色", "蓝色", "绿色", "黄色", "白色"],
      dutch_be: ["Rood", "Blauw", "Groen", "Geel", "Wit"],
      dutch_nl: ["Rood", "Blauw", "Groen", "Geel", "Wit"]
    },
    "Higher temperature": {
      english: ["increase temperature", "make it hotter", "raise the heat", "bump up temperature"],
      portuguese: ["Temperatura mais alta", "Aumentar temperatura"],
      spanish: ["Temperatura más alta", "Aumentar temperatura"],
      spanish_ar: ["Temperatura más alta", "Aumentar temperatura"],
      spanish_mx: ["Temperatura más alta", "Aumentar temperatura"],
      spanish_cl: ["Temperatura más alta", "Aumentar temperatura"],
      spanish_pe: ["Temperatura más alta", "Aumentar temperatura"],
      spanish_br: ["Temperatura mais alta", "Aumentar temperatura"],
      french: ["Température plus élevée", "Augmenter la température"],
      german: ["Höhere Temperatur", "Temperatur erhöhen"],
      italian: ["Temperatura più alta", "Aumenta temperatura"],
      chinese_tw: ["更高的溫度", "提高溫度"],
      chinese_cn: ["更高的温度", "提高温度"],
      chinese_sg: ["更高的温度", "提高温度"],
      dutch_be: ["Hogere temperatuur", "Temperatuur verhogen"],
      dutch_nl: ["Hogere temperatuur", "Temperatuur verhogen"]
    },
    "Lower temperature": {
      english: ["lower temperature", "decrease temperature", "make it cooler", "reduce the heat"],
      portuguese: ["Temperatura mais baixa", "Diminuir temperatura"],
      spanish: ["Temperatura más baja", "Disminuir temperatura"],
      spanish_ar: ["Temperatura más baja", "Disminuir temperatura"],
      spanish_mx: ["Temperatura más baja", "Disminuir temperatura"],
      spanish_cl: ["Temperatura más baja", "Disminuir temperatura"],
      spanish_pe: ["Temperatura más baja", "Disminuir temperatura"],
      spanish_br: ["Temperatura mais baixa", "Diminuir temperatura"],
      french: ["Température plus basse", "Diminuer la température"],
      german: ["Niedrigere Temperatur", "Temperatur senken"],
      italian: ["Temperatura più bassa", "Diminuisci temperatura"],
      chinese_tw: ["更低的溫度", "降低溫度"],
      chinese_cn: ["更低的温度", "降低温度"],
      chinese_sg: ["更低的温度", "降低温度"],
      dutch_be: ["Lagere temperatuur", "Temperatuur verlagen"],
      dutch_nl: ["Lagere temperatuur", "Temperatuur verlagen"]
    },
    "Set to cool mode": {
      english: ["set to cool mode", "start cooling", "cooling mode on"],
      portuguese: ["Definir para modo frio", "Modo frio"],
      spanish: ["Establecer modo frío", "Modo frío"],
      spanish_ar: ["Establecer modo frío", "Modo frío"],
      spanish_mx: ["Establecer modo frío", "Modo frío"],
      spanish_cl: ["Establecer modo frío", "Modo frío"],
      spanish_pe: ["Establecer modo frío", "Modo frío"],
      spanish_br: ["Definir para modo frio", "Modo frio"],
      french: ["Mettre en mode froid", "Mode froid"],
      german: ["Auf Kühlmodus einstellen", "Kühlmodus"],
      italian: ["Imposta modalità fredda", "Modalità fredda"],
      chinese_tw: ["設置為冷卻模式", "冷卻模式"],
      chinese_cn: ["设置为冷却模式", "冷却模式"],
      chinese_sg: ["设置为冷却模式", "冷却模式"],
      dutch_be: ["Ingesteld op koelmodus", "Koelmodus"],
      dutch_nl: ["Ingesteld op koelmodus", "Koelmodus"]
    },
    "Set to heat mode": {
      english: ["set to heat mode", "start heating", "heating mode on"],
      portuguese: ["Definir para modo aquecimento", "Modo aquecimento"],
      spanish: ["Establecer modo calor", "Modo calor"],
      spanish_ar: ["Establecer modo calor", "Modo calor"],
      spanish_mx: ["Establecer modo calor", "Modo calor"],
      spanish_cl: ["Establecer modo calor", "Modo calor"],
      spanish_pe: ["Establecer modo calor", "Modo calor"],
      spanish_br: ["Definir para modo aquecimento", "Modo aquecimento"],
      french: ["Mettre en mode chauffage", "Mode chauffage"],
      german: ["Auf Heizmodus einstellen", "Heizmodus"],
      italian: ["Imposta modalità riscaldamento", "Modalità riscaldamento"],
      chinese_tw: ["設置為加熱模式", "加熱模式"],
      chinese_cn: ["设置为加热模式", "加热模式"],
      chinese_sg: ["设置为加热模式", "加热模式"],
      dutch_be: ["Ingesteld op verwarmingsmodus", "Verwarmingsmodus"],
      dutch_nl: ["Ingesteld op verwarmingsmodus", "Verwarmingsmodus"]
    },
    "Set to low speed": {
      english: ["low fan", "set fan to low", "reduce speed"],
      portuguese: ["Definir para velocidade baixa", "Velocidade baixa"],
      spanish: ["Establecer velocidad baja", "Velocidad baja"],
      spanish_ar: ["Establecer velocidad baja", "Velocidad baja"],
      spanish_mx: ["Establecer velocidad baja", "Velocidad baja"],
      spanish_cl: ["Establecer velocidad baja", "Velocidad baja"],
      spanish_pe: ["Establecer velocidad baja", "Velocidad baja"],
      spanish_br: ["Definir para velocidade baixa", "Velocidade baixa"],
      french: ["Définir vitesse basse", "Vitesse basse"],
      german: ["Auf niedrige Geschwindigkeit einstellen", "Niedrige Geschwindigkeit"],
      italian: ["Imposta velocità bassa", "Velocità bassa"],
      chinese_tw: ["設定為低速", "低速"],
      chinese_cn: ["设置为低速", "低速"],
      chinese_sg: ["设置为低速", "低速"],
      dutch_be: ["Ingesteld op lage snelheid", "Lage snelheid"],
      dutch_nl: ["Ingesteld op lage snelheid", "Lage snelheid"]
    },
    "Set to medium speed": {
      english: ["medium fan", "set fan to medium", "medium speed"],
      portuguese: ["Definir para velocidade média", "Velocidade média"],
      spanish: ["Establecer velocidad media", "Velocidad media"],
      spanish_ar: ["Establecer velocidad media", "Velocidad media"],
      spanish_mx: ["Establecer velocidad media", "Velocidad media"],
      spanish_cl: ["Establecer velocidad media", "Velocidad media"],
      spanish_pe: ["Establecer velocidad media", "Velocidad media"],
      spanish_br: ["Definir para velocidade média", "Velocidade média"],
      french: ["Définir vitesse moyenne", "Vitesse moyenne"],
      german: ["Auf mittlere Geschwindigkeit einstellen", "Mittlere Geschwindigkeit"],
      italian: ["Imposta velocità media", "Velocità media"],
      chinese_tw: ["設定為中速", "中速"],
      chinese_cn: ["设置为中速", "中速"],
      chinese_sg: ["设置为中速", "中速"],
      dutch_be: ["Ingesteld op gemiddelde snelheid", "Gemiddelde snelheid"],
      dutch_nl: ["Ingesteld op gemiddelde snelheid", "Gemiddelde snelheid"]
    },
    "Set to high speed": {
      english: ["high fan", "set fan to high", "max speed"],
      portuguese: ["Definir para velocidade alta", "Velocidade alta"],
      spanish: ["Establecer velocidad alta", "Velocidad alta"],
      spanish_ar: ["Establecer velocidad alta", "Velocidad alta"],
      spanish_mx: ["Establecer velocidad alta", "Velocidad alta"],
      spanish_cl: ["Establecer velocidad alta", "Velocidad alta"],
      spanish_pe: ["Establecer velocidad alta", "Velocidad alta"],
      spanish_br: ["Definir para velocidade alta", "Velocidade alta"],
      french: ["Définir vitesse élevée", "Vitesse élevée"],
      german: ["Auf hohe Geschwindigkeit einstellen", "Hohe Geschwindigkeit"],
      italian: ["Imposta velocità alta", "Velocità alta"],
      chinese_tw: ["設定為高速", "高速"],
      chinese_cn: ["设置为高速", "高速"],
      chinese_sg: ["设置为高速", "高速"],
      dutch_be: ["Ingesteld op hoge snelheid", "Hoge snelheid"],
      dutch_nl: ["Ingesteld op hoge snelheid", "Hoge snelheid"]
    },
    "Set to auto": {
      english: ["auto mode", "automatic fan speed", "fan auto"],
      portuguese: ["Definir para automático", "Modo automático"],
      spanish: ["Establecer automático", "Modo automático"],
      spanish_ar: ["Establecer automático", "Modo automático"],
      spanish_mx: ["Establecer automático", "Modo automático"],
      spanish_cl: ["Establecer automático", "Modo automático"],
      spanish_pe: ["Establecer automático", "Modo automático"],
      spanish_br: ["Definir para automático", "Modo automático"],
      french: ["Définir automatique", "Mode automatique"],
      german: ["Auf Automatik einstellen", "Automatischer Modus"],
      italian: ["Imposta automatico", "Modalità automatica"],
      chinese_tw: ["設定為自動", "自動模式"],
      chinese_cn: ["设置为自动", "自动模式"],
      chinese_sg: ["设置为自动", "自动模式"],
      dutch_be: ["Ingesteld op automatisch", "Automatische modus"],
      dutch_nl: ["Ingesteld op automatisch", "Automatische modus"]
    },
    "Increase the fan speed": {
      english: ["speed up fan", "faster fan", "increase fan speed"],
      portuguese: ["Aumentar a velocidade do ventilador", "Acelerar o ventilador"],
      spanish: ["Aumentar la velocidad del ventilador", "Acelerar el ventilador"],
      spanish_ar: ["Aumentar la velocidad del ventilador", "Acelerar el ventilador"],
      spanish_mx: ["Aumentar la velocidad del ventilador", "Acelerar el ventilador"],
      spanish_cl: ["Aumentar la velocidad del ventilador", "Acelerar el ventilador"],
      spanish_pe: ["Aumentar la velocidad del ventilador", "Acelerar el ventilador"],
      spanish_br: ["Aumentar a velocidade do ventilador", "Acelerar o ventilador"],
      french: ["Augmenter la vitesse du ventilateur", "Accélérer le ventilateur"],
      german: ["Lüftergeschwindigkeit erhöhen", "Lüfter beschleunigen"],
      italian: ["Aumenta la velocità della ventola", "Accelera la ventola"],
      chinese_tw: ["增加風扇速度", "加快風扇"],
      chinese_cn: ["增加风扇速度", "加快风扇"],
      chinese_sg: ["增加风扇速度", "加快风扇"],
      dutch_be: ["Verhoog de ventilatorsnelheid", "Versnelle de ventilator"],
      dutch_nl: ["Verhoog de ventilatorsnelheid", "Versnelle de ventilator"]
    },
    "Decrease the fan speed": {
      english: ["slow down fan", "reduce fan speed"],
      portuguese: ["Diminuir a velocidade do ventilador", "Desacelerar o ventilador"],
      spanish: ["Disminuir la velocidad del ventilador", "Desacelerar el ventilador"],
      spanish_ar: ["Disminuir la velocidad del ventilador", "Desacelerar el ventilador"],
      spanish_mx: ["Disminuir la velocidad del ventilador", "Desacelerar el ventilador"],
      spanish_cl: ["Disminuir la velocidad del ventilador", "Desacelerar el ventilador"],
      spanish_pe: ["Disminuir la velocidad del ventilador", "Desacelerar el ventilador"],
      spanish_br: ["Diminuir a velocidade do ventilador", "Desacelerar o ventilador"],
      french: ["Diminuer la vitesse du ventilateur", "Ralentir le ventilateur"],
      german: ["Lüftergeschwindigkeit verringern", "Lüfter verlangsamen"],
      italian: ["Diminuisci la velocità della ventola", "Rallenta la ventola"],
      chinese_tw: ["降低風扇速度", "減慢風扇"],
      chinese_cn: ["降低风扇速度", "减慢风扇"],
      chinese_sg: ["降低风扇速度", "减慢风扇"],
      dutch_be: ["Verlaag de ventilatorsnelheid", "Vertrage de ventilator"],
      dutch_nl: ["Verlaag de ventilatorsnelheid", "Vertrage de ventilator"]
    },
    "Open blinds/curtains/shades": {
      english: ["open the blinds", "raise the shades", "pull up the curtains"],
      portuguese: ["Abrir persianas", "Abrir cortinas", "Abrir sombreadores"],
      spanish: ["Abrir persianas", "Abrir cortinas", "Abrir sombras"],
      spanish_ar: ["Abrir persianas", "Abrir cortinas", "Abrir sombras"],
      spanish_mx: ["Abrir persianas", "Abrir cortinas", "Abrir sombras"],
      spanish_cl: ["Abrir persianas", "Abrir cortinas", "Abrir sombras"],
      spanish_pe: ["Abrir persianas", "Abrir cortinas", "Abrir sombras"],
      spanish_br: ["Abrir persianas", "Abrir cortinas", "Abrir sombreadores"],
      french: ["Ouvrir les stores", "Ouvrir les rideaux", "Ouvrir les volets"],
      german: ["Jalousien öffnen", "Vorhänge öffnen", "Rollläden öffnen"],
      italian: ["Apri le persiane", "Apri le tende", "Apri gli scuri"],
      chinese_tw: ["打開百葉窗", "打開窗簾", "打開遮陽簾"],
      chinese_cn: ["打开百叶窗", "打开窗帘", "打开遮阳帘"],
      chinese_sg: ["打开百叶窗", "打开窗帘", "打开遮阳帘"],
      dutch_be: ["Jaloeziën openen", "Gordijnen openen", "Zonwering openen"],
      dutch_nl: ["Jaloeziën openen", "Gordijnen openen", "Zonwering openen"]
    },
    "Close blinds/curtains/shades": {
      english: ["close blinds", "pull down curtains"],
      portuguese: ["Fechar persianas", "Fechar cortinas", "Fechar sombreadores"],
      spanish: ["Cerrar persianas", "Cerrar cortinas", "Cerrar sombras"],
      spanish_ar: ["Cerrar persianas", "Cerrar cortinas", "Cerrar sombras"],
      spanish_mx: ["Cerrar persianas", "Cerrar cortinas", "Cerrar sombras"],
      spanish_cl: ["Cerrar persianas", "Cerrar cortinas", "Cerrar sombras"],
      spanish_pe: ["Cerrar persianas", "Cerrar cortinas", "Cerrar sombras"],
      spanish_br: ["Fechar persianas", "Fechar cortinas", "Fechar sombreadores"],
      french: ["Fermer les stores", "Fermer les rideaux", "Fermer les volets"],
      german: ["Jalousien schließen", "Vorhänge schließen", "Rollläden schließen"],
      italian: ["Chiudi le persiane", "Chiudi le tende", "Chiudi gli scuri"],
      chinese_tw: ["關閉百葉窗", "關閉窗簾", "關閉遮陽簾"],
      chinese_cn: ["关闭百叶窗", "关闭窗帘", "关闭遮阳帘"],
      chinese_sg: ["关闭百叶窗", "关闭窗帘", "关闭遮阳帘"],
      dutch_be: ["Jaloeziën sluiten", "Gordijnen sluiten", "Zonwering sluiten"],
      dutch_nl: ["Jaloeziën sluiten", "Gordijnen sluiten", "Zonwering sluiten"]
    },
    "Stop moving": {
      english: ["stop blinds", "freeze curtains", "stop movement"],
      portuguese: ["Parar de mover", "Parar"],
      spanish: ["Dejar de mover", "Parar"],
      spanish_ar: ["Dejar de mover", "Parar"],
      spanish_mx: ["Dejar de mover", "Parar"],
      spanish_cl: ["Dejar de mover", "Parar"],
      spanish_pe: ["Dejar de mover", "Parar"],
      spanish_br: ["Parar de mover", "Parar"],
      french: ["Arrêter le mouvement", "Arrêter"],
      german: ["Bewegung stoppen", "Stopp"],
      italian: ["Smetti di muoverti", "Ferma"],
      chinese_tw: ["停止移動", "停止"],
      chinese_cn: ["停止移动", "停止"],
      chinese_sg: ["停止移动", "停止"],
      dutch_be: ["Stop met bewegen", "Stop"],
      dutch_nl: ["Stop met bewegen", "Stop"]
    },
    "Raise the shades halfway": {
      english: ["raise halfway", "set shades to 50 percent"],
      portuguese: ["Levantar as persianas pela metade", "Meio aberto"],
      spanish: ["Subir las persianas a mitad", "A mitad de camino"],
      spanish_ar: ["Subir las persianas a mitad", "A mitad de camino"],
      spanish_mx: ["Subir las persianas a mitad", "A mitad de camino"],
      spanish_cl: ["Subir las persianas a mitad", "A mitad de camino"],
      spanish_pe: ["Subir las persianas a mitad", "A mitad de camino"],
      spanish_br: ["Levantar as persianas pela metade", "Meio aberto"],
      french: ["Relever les stores à mi-hauteur", "À mi-chemin"],
      german: ["Jalousien halbwegs hochfahren", "Halb oben"],
      italian: ["Alza le persiane a metà", "A metà strada"],
      chinese_tw: ["將遮陽簾升起一半", "一半的方式"],
      chinese_cn: ["将遮阳帘升起一半", "一半的方式"],
      chinese_sg: ["将遮阳帘升起一半", "一半的方式"],
      dutch_be: ["Zonwering halfweg omhoog", "Halfweg"],
      dutch_nl: ["Zonwering halfweg omhoog", "Halfweg"]
    },
    "What is the temperature?": {
      english: ["what is the temperature", "room temp", "temperature reading", "how hot is it", "tell me the temperature"],
      portuguese: ["Qual é a temperatura?", "Diga-me a temperatura"],
      spanish: ["¿Cuál es la temperatura?", "Dime la temperatura"],
      spanish_ar: ["¿Cuál es la temperatura?", "Dime la temperatura"],
      spanish_mx: ["¿Cuál es la temperatura?", "Dime la temperatura"],
      spanish_cl: ["¿Cuál es la temperatura?", "Dime la temperatura"],
      spanish_pe: ["¿Cuál es la temperatura?", "Dime la temperatura"],
      spanish_br: ["Qual é a temperatura?", "Diga-me a temperatura"],
      french: ["Quelle est la température?", "Dis-moi la température"],
      german: ["Wie ist die Temperatur?", "Sag mir die Temperatur"],
      italian: ["Qual è la temperatura?", "Dimmi la temperatura"],
      chinese_tw: ["溫度是多少？", "告訴我溫度"],
      chinese_cn: ["温度是多少？", "告诉我温度"],
      chinese_sg: ["温度是多少？", "告诉我温度"],
      dutch_be: ["Wat is de temperatuur?", "Zeg me de temperatuur"],
      dutch_nl: ["Wat is de temperatuur?", "Zeg me de temperatuur"]
    }
  },
  "Weather": {
    "General Weather Inquiries": {
      english: ["What is the weather?", "Tell me about the weather"],
      portuguese: ["Como está o clima?", "Fale sobre o clima"],
      spanish: ["Como esta el clima ?", "Dime sobre el clima"],
      spanish_ar: ["Como está el clima?", "Dame el clima"],
      spanish_mx: ["Como está el clima?", "Dime el clima"],
      spanish_cl: ["Como está el clima?", "Dime el clima"],
      spanish_pe: ["Como está el clima?", "Dime el clima"],
      spanish_br: ["Como está el clima?", "Dime el clima"],
      french: ["Quel sera le temps aujourd'hui ?", "Comment sera la météo aujourd'hui ?"],
      german: ["Wie ist das Wetter?", "Erzähl mir vom Wetter"],
      italian: ["com'e' il tempo?","com'e' oggi il tempo?", "parlami del meteo"],
      chinese_tw: ["天氣如何？", "告訴我天氣情況"],
      chinese_cn: ["天气如何？", "告诉我天气情况"],
      chinese_sg: ["天气如何？", "告诉我天气情况"],
      dutch_be: ["Wat is het weer vandaag?"],
      dutch_nl: ["Wat is het weer vandaag?"],
    },
    // "Location-Specific Queries": {
    //   english: ["What's the weather in country?", "Weather in country"],
    //   portuguese: ["Como está o clima em country?", "Clima em country"],
    //   spanish: ["Como está el clima en country?", "Clima en country"],
    //   spanish_ar: ["Como está el clima en country?", "Clima en country"],
    //   spanish_mx: ["Como está el clima en country?", "Clima en country"],
    //   spanish_cl: ["Como está el clima en country?", "Clima en country"],
    //   spanish_pe: ["Como está el clima en country?", "Clima en country"],
    //   spanish_br: ["Como está el clima en country?", "Clima em country"],
    //   french: ["Quel temps fait-il à country ?", "Météo à country"],
    //   german: ["Wie ist das Wetter in country?", "Wetter in country"],
    //   italian: ["Che tempo fa a country?", "Meteo a country"],
    //   chinese_tw: ["country 的天氣如何？", "country 的天氣"],
    //   chinese_cn: ["country 的天气如何？", "country 的天气"],
    //   chinese_sg: ["country 的天气如何？", "country 的天气"],
    //   dutch_be: ["Hoe is het weer in country?", "Weer in country"],
    //   dutch_nl: ["Hoe is het weer in country?", "Weer in country"]
    // },

    "Forecast & Planning Questions": {
      english: ["Will it rain tomorrow?"],
      portuguese: ["Vai chover amanhã?"],
      spanish: ["¿Lloverá mañana?"],
      spanish_ar: ["¿Lloverá mañana?"],
      spanish_mx: ["¿Lloverá mañana?"],
      spanish_cl: ["¿Lloverá mañana?"],
      spanish_pe: ["¿Lloverá mañana?"],
      spanish_br: ["¿Lloverá mañana?"],
      french: ["Va-t-il pleuvoir demain ?"],
      german: ["Regnet es morgen?"],
      italian: ["Pioverà domani?"],
      chinese_tw: ["明天會下雨嗎？", "週末的天氣預報是什麼？"],
      chinese_cn: ["明天会下雨吗？", "周末的天气预报是什么？"],
      chinese_sg: ["明天会下雨吗？", "周末的天气预报是什么？"],
      dutch_be: ["Gaat het morgen regenen?"],
      dutch_nl: ["Gaat het morgen regenen?"]
    },
    "Specific Conditions": {
      english: ["Is it sunny?"],
      portuguese: ["Está ensolarado?"],
      spanish: ["¿Está soleado?"],
      spanish_ar: ["¿Está soleado?"],
      spanish_mx: ["¿Está soleado?"],
      spanish_cl: ["¿Está soleado?"],
      spanish_pe: ["¿Está soleado?"],
      spanish_br: ["¿Está soleado?"],
      french: ["Est-ce ensoleillé ?"],
      german: ["Ist es sonnig?"],
      italian: ["È soleggiato?"],
      chinese_tw: ["天氣晴朗嗎？"],
      chinese_cn: ["天气晴朗吗？"],
      chinese_sg: ["天气晴朗吗？"],
      dutch_be: ["Is het zonnig?"],
      dutch_nl: ["Is het zonnig?"]
    }
  },
  "Channel control": {
    "Tune to channel by number":{
      english: ["Tune to channel by number"],
      portuguese: ["ir para o canal 5"],
      spanish: ["ir al canal 5"],
      spanish_ar: ["ir al canal 5"],
      spanish_mx: ["ir al canal 5"],
      spanish_cl: ["ir al canal 5"],
      spanish_pe: ["ir al canal 5"],
      spanish_br: ["ir al canal 5"],
      french: ["Va au program 5"],
      german:["Kanal 5", "Wechsle auf Kanal 5", "Gehe auf Kanal 5", "Gehe zu Kanal 5"],
      italian: ["Vai al canale cinque", "Metti il canale cinque"],
      chinese_tw: ["按頻道號碼切換"],
      chinese_cn: ["按频道号码切换"],
      chinese_sg: ["按频道号码切换"],
      dutch_be: ["Ga naar kanaal 5"],
      dutch_nl: ["Schakel naar"]
    },
    "Change Channel by Number": {
      english: ["Go to channel 5", "Switch to channel 5"],
      portuguese: ["Ir para o canal 5", "Assistir canal 5"],
      spanish: ["Ir al canal 5", "Ver canal 5"],
      spanish_ar: ["Ir al canal 5", "Ver canal 5"],
      spanish_mx: ["Ir al canal 5", "Ver canal 5"],
      spanish_cl: ["Ir al canal 5", "Ver canal 5"],
      spanish_pe: ["Ir al canal 5", "Ver canal 5"],
      spanish_br: ["Ir al canal 5", "Ver canal 5"], 
      french: ["Aller à la chaîne 5", "Passer à la chaîne 5"],
      german: ["Wechsle zu Kanal 5", "Schalte auf Kanal 5"],
      italian: ["Vai al canale 5", "Passa al canale 5"],
      chinese_tw: ["前往頻道5", "切換到頻道5"],
      chinese_cn: ["前往频道5", "切换到频道5"],
      chinese_sg: ["前往频道5", "切换到频道5"],
      dutch_be: ["Ga naar kanaal 5", "Schakel naar kanaal 5"],
      dutch_nl: ["Ga naar kanaal 5", "Schakel naar kanaal 5"]
    },
    "Change Channel by Name": {
      english: ["Go to channel BBC", "Switch to HBO"],
      portuguese: ["Ir para o canal BBC", "Assistir HBO"],
      spanish: ["Ir al canal BBC", "Ver HBO"],
      spanish_ar: ["Ir al canal BBC", "Ver HBO"],
      spanish_mx: ["Ir al canal BBC", "Ver HBO"],
      spanish_cl: ["Ir al canal BBC", "Ver HBO"],
      spanish_pe: ["Ir al canal BBC", "Ver HBO"],
      spanish_br: ["Ir al canal BBC", "Ver HBO"], 
      french: ["Aller à BBC", "Passer à HBO"],
      german: ["Wechsle zu BBC", "Schalte auf HBO"],
      italian: ["Vai a BBC", "Passa a HBO"],
      chinese_tw: ["前往頻道BBC", "切換到HBO"],
      chinese_cn: ["前往频道BBC", "切换到HBO"],
      chinese_sg: ["前往频道BBC", "切换到HBO"],
      dutch_be: ["Ga naar kanaal BBC", "Schakel naar HBO"],
      dutch_nl: ["Ga naar kanaal BBC", "Schakel naar HBO"]
    },
    "Channel Up": {
      english: ["Channel up", "Next channel"],
      portuguese: ["Subir canal", "Próximo canal"],
      spanish: ["Subir canal", "Canal siguiente"],
      spanish_ar: ["Subir canal", "Canal siguiente"],
      spanish_mx: ["Subir canal", "Canal siguiente"],
      spanish_cl: ["Subir canal", "Canal siguiente"],
      spanish_pe: ["Subir canal", "Canal siguiente"],
      spanish_br: ["Subir canal", "Canal siguiente"], 
      french: ["Chaîne suivante", "Canal +"],
      german: ["Nächster Kanal", "Kanal hoch"],
      italian: ["Canale successivo", "Avanti canale"],
      chinese_tw: ["頻道向上", "下一個頻道"],
      chinese_cn: ["频道向上", "下一个频道"],
      chinese_sg: ["频道向上", "下一个频道"],
      dutch_be: ["Kanaal omhoog", "Volgend kanaal"],
      dutch_nl: ["Kanaal omhoog", "Volgend kanaal"]
    },
    "Channel Down": {
      english: ["Channel down", "Previous channel"],
      portuguese: ["Descer canal", "Canal anterior"],
      spanish: ["Bajar canal", "Canal anterior"],
      spanish_ar: ["Bajar canal", "Canal anterior"],
      spanish_mx: ["Bajar canal", "Canal anterior"],
      spanish_cl: ["Bajar canal", "Canal anterior"],
      spanish_pe: ["Bajar canal", "Canal anterior"],
      spanish_br: ["Bajar canal", "Canal anterior"], 
      french: ["Chaîne précédente", "Canal –"],
      german: ["Vorheriger Kanal", "Kanal runter"],
      italian: ["Canale precedente", "Indietro canale"],
      chinese_tw: ["頻道向下", "上一個頻道"],
      chinese_cn: ["频道向下", "上一个频道"],
      chinese_sg: ["频道向下", "上一个频道"],
      dutch_be: ["Kanaal omlaag", "Vorig kanaal"],
      dutch_nl: ["Kanaal omlaag", "Vorig kanaal"]
    }
  },
  "Playback control": {
    "Resume TV": {
      english: ["Resume TV"],
      portuguese: ["Retomar TV", "Continuar TV"],
      spanish: ["Reanudar TV", "Continuar TV"],
      spanish_ar: ["Reanudar TV", "Continuar TV"],
      spanish_mx: ["Reanudar TV", "Continuar TV"],
      spanish_cl: ["Reanudar TV", "Continuar TV"],
      spanish_pe: ["Reanudar TV", "Continuar TV"],
      spanish_br: ["Retomar TV", "Continuar TV"],
      french: ["Reprendre la TV", "Relancer la TV"],
      german: ["Fernsehen fortsetzen", "Weiterschalten"],
      italian: ["Riprendi TV", "Continua TV"],
      chinese_tw: ["繼續播放電視"],
      chinese_cn: ["继续播放电视"],
      chinese_sg: ["继续播放电视"],
      dutch_be: ["Hervat TV", "Verder kijken"],
      dutch_nl: ["Hervat TV", "Verder kijken"]
    },
    "Stop": {
      english: ["Stop"],
      portuguese: ["Parar", "Interromper"],
      spanish: ["Detener", "Parar"],
      spanish_ar: ["Detener", "Parar"],
      spanish_mx: ["Detener", "Parar"],
      spanish_cl: ["Detener", "Parar"],
      spanish_pe: ["Detener", "Parar"],
      spanish_br: ["Parar", "Interromper"],
      french: ["Arrêter", "Stop"],
      german: ["Stopp", "Anhalten"],
      italian: ["Ferma", "Interrompi"],
      chinese_tw: ["停止"],
      chinese_cn: ["停止"],
      chinese_sg: ["停止"],
      dutch_be: ["Stop", "Ophouden"],
      dutch_nl: ["Stop", "Ophouden"]
    },
    "Pause": {
      english: ["Pause"],
      portuguese: ["Pausar"],
      spanish: ["Pausar"],
      spanish_ar: ["Pausar"],
      spanish_mx: ["Pausar"],
      spanish_cl: ["Pausar"],
      spanish_pe: ["Pausar"],
      spanish_br: ["Pausar"],
      french: ["Pause", "Mettre en pause"],
      german: ["Pause", "Pausieren"],
      italian: ["Pausa", "Metti in pausa"],
      chinese_tw: ["暫停"],
      chinese_cn: ["暂停"],
      chinese_sg: ["暂停"],
      dutch_be: ["Pauzeren"],
      dutch_nl: ["Pauzeren"]
    },
    "Play TV": {
      english: ["Play TV"],
      portuguese: ["Reproduzir TV", "Tocar TV"],
      spanish: ["Reproducir TV", "Iniciar TV"],
      spanish_ar: ["Reproducir TV", "Iniciar TV"],
      spanish_mx: ["Reproducir TV", "Iniciar TV"],
      spanish_cl: ["Reproducir TV", "Iniciar TV"],
      spanish_pe: ["Reproducir TV", "Iniciar TV"],
      spanish_br: ["Reproduzir TV", "Tocar TV"],
      french: ["Lire la TV", "Démarrer la TV"],
      german: ["Fernsehen abspielen", "TV starten"],
      italian: ["Riproduci TV", "Avvia TV"],
      chinese_tw: ["播放電視"],
      chinese_cn: ["播放电视"],
      chinese_sg: ["播放电视"],
      dutch_be: ["TV afspelen", "Start TV"],
      dutch_nl: ["TV afspelen", "Start TV"]
    },
    "Next": {
      english: ["Next"],
      portuguese: ["Próximo", "Avançar"],
      spanish: ["Siguiente", "Avanzar"],
      spanish_ar: ["Siguiente", "Avanzar"],
      spanish_mx: ["Siguiente", "Avanzar"],
      spanish_cl: ["Siguiente", "Avanzar"],
      spanish_pe: ["Siguiente", "Avanzar"],
      spanish_br: ["Próximo", "Avançar"],
      french: ["Suivant", "Prochain"],
      german: ["Weiter", "Nächstes"],
      italian: ["Successivo", "Prossimo"],
      chinese_tw: ["下一個"],
      chinese_cn: ["下一个"],
      chinese_sg: ["下一个"],
      dutch_be: ["Volgende"],
      dutch_nl: ["Volgende"]
    },
    "Previous": {
      english: ["Previous"],
      portuguese: ["Anterior", "Retroceder"],
      spanish: ["Anterior", "Retroceder"],
      spanish_ar: ["Anterior", "Retroceder"],
      spanish_mx: ["Anterior", "Retroceder"],
      spanish_cl: ["Anterior", "Retroceder"],
      spanish_pe: ["Anterior", "Retroceder"],
      spanish_br: ["Anterior", "Retroceder"],
      french: ["Précédent", "Avant"],
      german: ["Zurück", "Vorheriges"],
      italian: ["Precedente", "Indietro"],
      chinese_tw: ["上一個"],
      chinese_cn: ["上一个"],
      chinese_sg: ["上一个"],
      dutch_be: ["Vorige", "Terug"],
      dutch_nl: ["Vorige", "Terug"]
    }
  },
  "Launch OTT Apps": {
    "Launch YouTube": {
      english: ["Launch YouTube"],
      portuguese: ["Abrir o YouTube"],
      spanish: ["Abrir YouTube"],
      spanish_ar: ["Abrir YouTube"],
      spanish_mx: ["Abrir YouTube"],
      spanish_cl: ["Abrir YouTube"],
      spanish_pe: ["Abrir YouTube"],
      spanish_br: ["Abrir YouTube"],
      french: ["Ouvre YouTube"],
      german: ["Öffne YouTube"],
      italian: ["lancia youtube"],
      chinese_tw: ["啟動YouTube"],
      chinese_cn: ["启动YouTube"],
      chinese_sg: ["启动YouTube"],
      dutch_be: ["Open Youtube"],
      dutch_nl: ["Open Youtube"]
    },
    "Open YouTube": {
      english: ["Open YouTube"],
      portuguese: ["abra o YouTube"],
      spanish: ["Abrir YouTube"],
      spanish_ar: ["Abrir YouTube"],
      spanish_mx: ["Abrir YouTube"],
      spanish_cl: ["Abrir YouTube"],
      spanish_pe: ["Abrir YouTube"],
      spanish_br: ["Abrir YouTube"],
      french: ["Demarre YouTube "],
      german: ["YouTube starten"],
      italian: ["apri youtube"],
      chinese_tw: ["開啟YouTube"],
      chinese_cn: ["打开YouTube"],
      chinese_sg: ["打开YouTube"],
      dutch_be: ["Start Youtube"],
      dutch_nl: ["Start Youtube"]
    },
    "YouTube": {
      english: ["YouTube"],
      portuguese: ["YouTube"],
      spanish: ["YouTube"],
      spanish_ar: ["YouTube"],
      spanish_mx: ["YouTube"],
      spanish_cl: ["YouTube"],
      spanish_pe: ["YouTube"],
      spanish_br: ["YouTube"],
      french: ["YouTube"],
      german: ["YouTube"],
      italian: ["youTube"],
      chinese_tw: ["YouTube"],
      chinese_cn: ["YouTube"],
      chinese_sg: ["YouTube"],
      dutch_be: ["YouTube"],
      dutch_nl: ["YouTube"]
    },
    "Launch Netflix": {
      english: ["Launch Netflix"],
      portuguese: ["Abrir o Netflix"],
      spanish: ["Abrir Netflix"],
      spanish_ar: ["Abrir Netflix"],
      spanish_mx: ["Abrir Netflix"],
      spanish_cl: ["Abrir Netflix"],
      spanish_pe: ["Abrir Netflix"],
      spanish_br: ["Abrir Netflix"],
      french: ["Ouvre Netflix"],
      german: ["Öffne Netflix"],
      italian: ["lancia netflix"],
      chinese_tw: ["啟動Netflix"],
      chinese_cn: ["启动Netflix"],
      chinese_sg: ["启动Netflix"],
      dutch_be: ["Open Netflix"],
      dutch_nl: ["Open Netflix"]
    },
    "Open Netflix": {
      english: ["Open Netflix"],
      portuguese: ["abra o Netflix"],
      spanish: ["Abrir Netflix"],
      spanish_ar: ["Abrir Netflix"],
      spanish_mx: ["Abrir Netflix"],
      spanish_cl: ["Abrir Netflix"],
      spanish_pe: ["Abrir Netflix"],
      spanish_br: ["Abrir Netflix"],
      french: ["Demarre Netflix"],
      german: ["Netflix starten"],
      italian: ["apri netflix"],
      chinese_tw: ["開啟Netflix"],
      chinese_cn: ["打开Netflix"],
      chinese_sg: ["打开Netflix"],
      dutch_be: ["Start Netflix"],
      dutch_nl: ["Start Netflix"]
    },
    "Netflix": {
      english: ["Netflix"],
      portuguese: ["Netflix"],
      spanish: ["Netflix"],
      spanish_ar: ["Netflix"],
      spanish_mx: ["Netflix"],
      spanish_cl: ["Netflix"],
      spanish_pe: ["Netflix"],
      spanish_br: ["Netflix"],
      french: ["Netflix"],
      german: ["Netflix"],
      italian: ["netflix"],
      chinese_tw: ["Netflix"],
      chinese_cn: ["Netflix"],
      chinese_sg: ["Netflix"],
      dutch_be: ["Netflix"],
      dutch_nl: ["Netflix"]
    },
    "Launch Prime Video": {
      english: ["Launch Prime Video", "Start Prime Video"],
      portuguese: ["Abrir o Prime Video", "Começar Prime Video"],
      spanish: ["Abrir Prime Video", "Iniciar Prime Video"],
      spanish_ar: ["Abrir Prime Video", "Iniciar Prime Video"],
      spanish_mx: ["Abrir Prime Video", "Iniciar Prime Video"],
      spanish_cl: ["Abrir Prime Video", "Iniciar Prime Video"],
      spanish_pe: ["Abrir Prime Video", "Iniciar Prime Video"],
      spanish_br: ["Abrir Prime Video", "Iniciar Prime Video"],
      french: ["Ouvre Prime Vidéo", "Démarrer Prime Video"],
      german: ["Öffne Prime Video", "Prime Video öffnen"],
      italian: ["lancia prime video", "Inizia Prime Video"],
      chinese_tw: ["啟動Prime Video", "開始Prime Video"],
      chinese_cn: ["启动Prime Video", "开始Prime Video"],
      chinese_sg: ["启动Prime Video", "开始Prime Video"],
      dutch_be: ["Prime Video starten", "Prime Video openen"],
      dutch_nl: ["Prime Video starten", "Prime Video openen"]
    },
    "Open Prime Video": {
      english: ["Open Prime Video"],
      portuguese: ["Abra Prime video"],
      spanish: ["Abrir Prime video"],
      spanish_ar: ["Abrir Prime video"],
      spanish_mx: ["Abrir Prime Video"],
      spanish_cl: ["Abrir Prime Video"],
      spanish_pe: ["Abrir Prime Video"],
      spanish_br: ["Abrir Prime Video"],
      french: ["Demarre Prime Vidéo"],
      german: ["Prime Video starten"],
      italian: ["apri prime video"],
      chinese_tw: ["開啟Prime Video"],
      chinese_cn: ["打开Prime Video"],
      chinese_sg: ["打开Prime Video"],
      dutch_be: ["Start Prime Video"],
      dutch_nl: ["Start Prime Video"]
    },
    "Prime Video": {
      english: ["Prime Video"],
      portuguese: ["Prime video"],
      spanish: ["Prime Video"],
      spanish_ar: ["Prime Video"],
      spanish_mx: ["Prime Video"],
      spanish_cl: ["Prime Video"],
      spanish_pe: ["Prime Video"],
      spanish_br: ["Prime Video"],
      french: ["Prime Vidéo"],
      german: ["Prime Video"],
      italian: ["prime video"],
      chinese_tw: ["Prime Video"],
      chinese_cn: ["Prime Video"],
      chinese_sg: ["Prime Video"],
      dutch_be: ["Prime Video"],
      dutch_nl: ["Prime Video"]
    }
  },
  "Global Search": {
    "Search for Spiderman movie": {
      english: ["Search for Spiderman movie", "Find Spiderman movie"],
      portuguese: ["procurar filme do homem-aranha", "Encontrar filme do Homem-Aranha"],
      spanish: ["buscar la película spiderman", "Encontrar película de Spiderman"],
      spanish_ar: ["buscar la película spiderman", "Encontrar película de Spiderman"],
      spanish_mx: ["buscar la película spiderman", "Encontrar película de Spiderman"],
      spanish_cl: ["buscar la película spiderman", "Encontrar película de Spiderman"],
      spanish_pe: ["buscar la película spiderman", "Encontrar película de Spiderman"],
      spanish_br: ["buscar la película spiderman", "Encontrar película de Spiderman"],
      french: ["Cherche le film Spiderman", "Trouver le film Spider-Man"],
      german: ["Suche Spider-Man Film", "Spider-Man-Film finden"],
      italian: ["cerca il film spider-man", "Trova film Spider-Man"],
      chinese_tw: ["搜索蜘蛛人電影", "尋找蜘蛛人電影"],
      chinese_cn: ["搜索蜘蛛侠电影", "寻找蜘蛛侠电影"],
      chinese_sg: ["搜索蜘蛛侠电影", "寻找蜘蛛侠电影"],
      dutch_be: ["Zoek Spiderman film", "Zoek Spiderman filme"],
      dutch_nl: ["Zoek Spiderman film", "Zoek Spiderman filme"],
    },
    "Search for Spiderman movie on YouTube": {
      english: ["Search for Spiderman movie on YouTube", "Find Spiderman movie on YouTube"],
      portuguese: ["buscar pelicula de spiderman en youtube", "procurar filme do homem-aranha no youtube"],
      spanish: ["Buscar película de Spider-Man en YouTube", "Encontrar película de Spiderman en YouTube"],
      spanish_ar: ["buscar pelicula de spiderman en youtube", "Encontrar película de Spiderman en YouTube"],
      spanish_mx: ["Buscar película de Spiderman en YouTube", "Encontrar película de Spiderman en YouTube"],
      spanish_cl: ["Buscar película de Spiderman en YouTube", "Encontrar película de Spiderman en YouTube"],
      spanish_pe: ["Buscar película de Spiderman en YouTube", "Encontrar película de Spiderman en YouTube"],
      spanish_br: ["Buscar película de Spiderman en YouTube", "Encontrar película de Spiderman en YouTube"],
      french: ["Cherche le film Spiderman", "Cherche le film Spiderman sur YouTube"],
      german: ["Suche Spider-Man Film auf YouTube", "Suche Spider-Man Film auf YouTube"],
      italian: ["Cerca film Spiderman su YouTube", "Trova film Spiderman su YouTube"],
      chinese_tw: ["在YouTube上搜索蜘蛛人電影", "在YouTube上尋找蜘蛛人電影"],
      chinese_cn: ["在YouTube上搜索蜘蛛侠电影", "在YouTube上寻找蜘蛛侠电影"],
      chinese_sg: ["在YouTube上搜索蜘蛛侠电影", "在YouTube上寻找蜘蛛侠电影"],
      dutch_be: ["Zoek naar Spiderman film op Youtube", "Vind Spiderman-film op YouTube"],
      dutch_nl: ["Zoek naar Spiderman film op Youtube", "Vind Spiderman-film op YouTube"],
    }
  },

  "Power on/off": {
    "Turn On": {
      english: ["Turn on TV", "Switch on TV", "Wake up TV"],
      portuguese: ["Ligar TV", "Ativar TV", "Despertar TV"],
      spanish: ["Encender la tele", "Poner la tele", "Encender el televisor"],
      spanish_ar: ["Encender la TV", "Prender la TV", "Despertar la TV"],
      spanish_mx: ["Prender la tele", "Encender la TV", "Despertar la TV"],
      spanish_cl: ["Encender la TV", "Prender la TV", "Despertar la TV"],
      spanish_pe: ["Encender la TV", "Prender la TV", "Activar la TV"], 
      spanish_br: ["Encender la TV", "Prender la TV", "Activar la TV"], 
      french: ["Allumer la TV", "Mettre la TV en marche"],
      german: ["TV einschalten", "Fernseher einschalten"],
      italian: ["Accendi la TV", "Avvia la TV"],
      chinese_tw: ["開電視", "啟動電視", "喚醒電視"],
      chinese_cn: ["开电视", "启动电视", "唤醒电视"],
      chinese_sg: ["开电视", "启动电视", "唤醒电视"],
      dutch_be: ["TV aanzetten", "Televisie inschakelen", "TV activeren"],
      dutch_nl: ["TV aanzetten", "Televisie inschakelen", "TV activeren"]
    },
    "Turn Off": {
      english: ["Turn off TV", "Switch off TV"],
      portuguese: ["Desligar TV", "Desativar TV"],
      spanish: ["Apagar la tele", "Apagar el televisor", "Quitar la tele"],
      spanish_ar: ["Apagar la TV", "Desactivar la TV"],
      spanish_mx: ["Apagar la tele", "Desactivar la TV"],
      spanish_cl: ["Apagar la TV", "Desactivar la TV"],
      spanish_pe: ["Apagar la TV", "Desactivar la TV"],
      spanish_br: ["Apagar la TV", "Desactivar la TV"],
      french: ["Éteindre la TV", "Couper la TV"],
      german: ["TV ausschalten", "Fernseher aus"],
      italian: ["Spegni la TV", "Arresta la TV"],
      chinese_tw: ["關閉電視", "關掉電視"],
      chinese_cn: ["关闭电视", "关掉电视"],
      chinese_sg: ["关闭电视", "关掉电视"],
      dutch_be: ["TV uitzetten", "Televisie uitschakelen"],
      dutch_nl: ["TV uitzetten", "Televisie uitschakelen"]
    }
  },
  "Volume control": {
    "Volume Up": {
      english: ["Volume Up", "Raise TV volume", "Increase volume", "Volume up on TV"],
      portuguese: ["Aumentar o volume da TV", "Subir volume"],
      spanish: ["Subir volumen", "Subir volumen en TV"],
      spanish_ar: ["Subir volumen", "Subir volumen en TV"],
      spanish_mx: ["Subir volumen", "Aumentar volumen"],
      spanish_cl: ["Subir volumen", "Aumentar volumen"],
      spanish_pe: ["Subir volumen", "Aumentar volumen"],
      spanish_br: ["Subir volumen", "Aumentar volumen"], 
      french: ["Augmenter le son", "Augmenter le volume"],
      german: ["Lauter", "TV Lautstärke erhöhen", "Lautstärke erhöhen", "TV lauter stellen"],
      italian: ["Alza il volume della TV", "Aumenta volume TV", "Volume più alto"],
      chinese_tw: ["調高電視音量", "增加音量"],
      chinese_cn: ["调高电视音量", "增加音量"],
      chinese_sg: ["调高电视音量", "增加音量"],
      dutch_be: ["TV volume verhogen", "Geluid harder zetten"],
      dutch_nl: ["TV volume verhogen", "Geluid harder zetten"]
    },
    "Volume Down": {
      english: ["Volume Down", "Lower TV volume", "Decrease volume", "Volume down on TV"],
      portuguese: ["Diminuir o volume da TV", "Baixar volume", "Diminuir volume"],
      spanish: ["Bajar volumen"],
      spanish_ar: ["Bajar volumen", "Bajar volumen en TV"],
      spanish_mx: ["Bajar volumen", "Reducir volumen"],
      spanish_cl: ["Bajar volumen", "Disminuir volumen"],
      spanish_pe: ["Bajar volumen", "Reducir volumen"],
      spanish_br: ["Bajar volumen", "Reducir volumen"], 
      french: ["Diminuer le son", "Diminuer le volume", "Baisser le son", "Baisser le volume"],
      german: ["Leiser", "TV Lautstärke verringern"],
      italian: ["Abbassa il volume della TV"],
      chinese_tw: ["調低電視音量", "減少音量"],
      chinese_cn: ["调低电视音量", "减少音量"],
      chinese_sg: ["调低电视音量", "减少音量"],
      dutch_be: ["TV volume verlagen", "Geluid zachter zetten"],
      dutch_nl: ["TV volume verlagen", "Geluid zachter zetten"]
    },
    "Set Volume Level": {
      english: ["Set volume to 0-60", "Set volume to <xx> on TV"],
      portuguese: ["Definir volume para 0-60", "Definir volume para <xx> na TV"],
      spanish: ["Ajustar volumen a 0-60", "Ajustar volumen a <xx> en TV"],
      spanish_ar: ["Ajustar volumen a 0-60", "Ajustar volumen a <xx> en TV"],
      spanish_mx: ["Ajustar volumen a 0-60", "Subir volumen a <xx>"],
      spanish_cl: ["Ajustar volumen a 0-60", "Subir volumen a <xx>"],
      spanish_pe: ["Ajustar volumen a 0-60", "Subir volumen a <xx>"],
      spanish_br: ["Ajustar volumen a 0-60", "Ajustar volumen a <xx>"], 
      french: ["Régler le volume à 0–60", "Volume à <xx> TV"],
      german: ["Lautstärke auf 0–60 einstellen", "Lautstärke auf <xx>"],
      italian: ["Imposta volume 0–60", "Volume a <xx> TV"],
      chinese_tw: ["將音量設定為0-60", "將電視音量設為<xx>"],
      chinese_cn: ["将音量设置为0-60", "将电视音量设为<xx>"],
      chinese_sg: ["将音量设置为0-60", "将电视音量设为<xx>"],
      dutch_be: ["Volume instellen op 0-60", "Volume op <xx> zetten"],
      dutch_nl: ["Volume instellen op 0-60", "Volume op <xx> zetten"]
    },
    "Numbers 0-60": {
      english: ['Record the numbers from "1" to "120"'],
      portuguese: ['Gravar os números de "1" a "120"'],
      spanish: ['Grabar los números del "1" al "120"'],
      spanish_ar: ['Grabar los números del "1" al "120"'],
      spanish_mx: ['Grabar los números del "1" al "120"'],
      spanish_cl: ['Grabar los números del "1" al "120"'],
      spanish_pe: ['Grabar los números del "1" al "120"'],
      spanish_br: ['Grabar los números del "1" al "120"'], 
      french: ['Enregistrer les nombres de "1" à "120"'],
      german: ['Nummern von "1" bis "120" aufzeichnen'],
      italian: ['Registra numeri da "1" a "120"'],
      chinese_tw: ['錄製數字從"1"到"120"'],
      chinese_cn: ['录制数字从"1"到"120"'],
      chinese_sg: ['录制数字从"1"到"120"'],
      dutch_be: ['Nummers van "1" tot "120" opnemen'],
      dutch_nl: ['Nummers van "1" tot "120" opnemen']
    },
    "Mute": {
      english: ["Mute", "Mute TV"],
      portuguese: ["Silenciar a TV", "Colocar no mudo", "Ativar o mudo"],
      spanish: ["Silenciar la TV"],
      spanish_ar: ["Silenciar la TV"],
      spanish_mx: ["Silenciar la TV"],
      spanish_cl: ["Silenciar la TV"],
      spanish_pe: ["Silenciar la TV"],
      spanish_br: ["Silenciar la TV"],
      french: ["Couper le son"],
      german: ["Ton aus", "Stummschalten"],
      italian: ["Metti in muto la TV", "Togli il volume alla TV"],
      chinese_tw: ["電視靜音"],
      chinese_cn: ["电视静音"],
      chinese_sg: ["电视静音"],
      dutch_be: ["Geluid uitzetten", "Geluid dempen"],
      dutch_nl: ["Geluid uitzetten", "Geluid dempen"]
    },
    "Unmute": {
      english: ["Unmute", "Unmute TV"],
      portuguese: ["Desmutar a TV", "Tirar do mudo"],
      spanish: ["Encender sonido en TV"],
      spanish_ar: ["Activar sonido en TV", "Encender sonido en TV"],
      spanish_mx: ["Activar sonido en TV", "Encender sonido en TV"],
      spanish_cl: ["Activar sonido en TV", "Encender sonido en TV"],
      spanish_pe: ["Activar sonido en TV", "Encender sonido en TV"],
      spanish_br: ["Activar sonido en TV", "Encender sonido en TV"],
      french: ["Rétablir le son", "Remettre le son"],
      german: ["Ton an", "Stummschaltung aufheben", "Stummschaltung aus"],
      italian: ["Attiva il volume alla TV"],
      chinese_tw: ["取消電視靜音"],
      chinese_cn: ["取消电视静音"],
      chinese_sg: ["取消电视静音"],
      dutch_be: ["Geluid aanzetten"],
      dutch_nl: ["Geluid aanzetten"]
    }
  },
  "Launch target/shortcut": {
    "Open OTT Apps (YouTube, Netflix, Amazon Prime, etc)": {
      english: ["Open YouTube", "Launch Netflix", "Start Prime Video"],
      portuguese: ["Abrir YouTube", "Abrir Netflix", "Iniciar Prime Video"],
      spanish: ["Abrir YouTube", "Abrir Netflix", "Iniciar Prime Video"],
      spanish_ar: ["Abrir YouTube", "Abrir Netflix", "Iniciar Prime Video"],
      spanish_mx: ["Abrir YouTube", "Abrir Netflix", "Iniciar Prime Video"],
      spanish_cl: ["Abrir YouTube", "Abrir Netflix", "Iniciar Prime Video"],
      spanish_pe: ["Abrir YouTube", "Abrir Netflix", "Iniciar Prime Video"],
      spanish_br: ["Abrir YouTube", "Abrir Netflix", "Iniciar Prime Video"], 
      french: ["Ouvrir YouTube", "Lancer Netflix", "Démarrer Prime Video"],
      german: ["YouTube öffnen", "Netflix starten", "Prime Video öffnen"],
      italian: ["Apri YouTube", "Avvia Netflix", "Avvia Prime Video"],
      chinese_tw: ["開啟YouTube", "啟動Netflix", "開始Prime Video"],
      chinese_cn: ["打开YouTube", "启动Netflix", "开始Prime Video"],
      chinese_sg: ["打开YouTube", "启动Netflix", "开始Prime Video"],
      dutch_be: ["YouTube openen", "Netflix starten", "Prime Video starten"],
      dutch_nl: ["YouTube openen", "Netflix starten", "Prime Video starten"]
    },
    "Go Home": {
      english: ["Go Home", "Return to Home"],
      portuguese: ["Ir para Casa", "Voltar para o início"],
      spanish: ["Ir a Casa", "Volver al inicio"],
      spanish_ar: ["Ir a Casa", "Volver al inicio"],
      spanish_mx: ["Ir a Inicio", "Volver al inicio"],
      spanish_cl: ["Ir a Inicio", "Volver al inicio"],
      spanish_pe: ["Ir a Inicio", "Volver al inicio"],
      spanish_br: ["Ir a Inicio", "Volver al inicio"], 
      french: ["Aller à l'accueil", "Retour à l'écran principal"],
      german: ["Zum Startbildschirm", "Zurück Home"],
      italian: ["Vai alla home", "Torna alla home"],
      chinese_tw: ["返回主頁", "回到主頁"],
      chinese_cn: ["返回主页", "回到主页"],
      chinese_sg: ["返回主页", "回到主页"],
      dutch_be: ["Naar Home", "Terug naar Home"],
      dutch_nl: ["Naar Home", "Terug naar Home"]
    },
"Go to Setting": {
  english: ["Open setting", "Go to setting"],
  portuguese: ["Abrir configurações", "Ir para configurações"],
  spanish: ["Abrir configuraciones", "Ir a configuraciones"],
  spanish_ar: ["Abrir configuraciones", "Ir a configuraciones"],
  spanish_mx: ["Abrir ajustes", "Ir a ajustes"],
  spanish_cl: ["Abrir configuraciones", "Ir a configuraciones"],
  spanish_pe: ["Abrir configuraciones", "Ir a configuraciones"],
  spanish_br: ["Abrir configuraciones", "Ir a configuraciones"],
  french: ["Ouvrir les paramètres", "Aller aux paramètres"],
  german: ["Einstellungen öffnen", "Zu den Einstellungen"],
  italian: ["Apri impostazioni", "Vai alle impostazioni"],
  chinese_tw: ["開啟設定", "前往設定"],
  chinese_cn: ["打开设置", "转到设置"],
  chinese_sg: ["打开设置", "转到设置"],
  dutch_be: ["Instellingen openen", "Naar instellingen"],
  dutch_nl: ["Instellingen openen", "Naar instellingen"]
}
  },
  "Content search": {
    "Global Search and Display (Launcher)": {
      english: ["Show me content", "Search for content"],
      portuguese: ["Mostrar conteúdo", "Pesquisar conteúdo"],
      spanish: ["Mostrar contenido", "Buscar contenido"],
      spanish_ar: ["Mostrar contenido", "Buscar contenido"],
      spanish_mx: ["Muéstrame contenido", "Buscar contenido"],
      spanish_cl: ["Mostrar contenido", "Buscar contenido"],
      spanish_pe: ["Mostrar contenido", "Buscar contenido"],
      spanish_br: ["Mostrar contenido", "Buscar contenido"], 
      french: ["Afficher du contenu", "Rechercher du contenu"],
      german: ["Inhalt anzeigen", "Inhalt suchen"],
      italian: ["Mostra contenuto", "Cerca contenuto"],
      chinese_tw: ["顯示內容", "搜索內容"],
      chinese_cn: ["显示内容", "搜索内容"],
      chinese_sg: ["显示内容", "搜索内容"],
      dutch_be: ["Toon inhoud", "Zoek naar inhoud"],
      dutch_nl: ["Toon inhoud", "Zoek naar inhoud"]
    },
    "YouTube search (certification)": {
      english: ["Search YouTube certification videos", "YouTube certification search"],
      portuguese: ["Pesquisar vídeos de certificação no YouTube", "Busca certificação YouTube"],
      spanish: ["Buscar videos de certificación en YouTube", "Búsqueda YouTube certificación"],
      spanish_ar: ["Buscar videos de certificación en YouTube", "Búsqueda YouTube certificación"],
      spanish_mx: ["Buscar videos de certificación en YouTube", "Búsqueda YouTube certificación"],
      spanish_cl: ["Buscar videos de certificación en YouTube", "Búsqueda YouTube certificación"],
      spanish_pe: ["Buscar videos de certificación en YouTube", "Búsqueda YouTube certificación"],
      spanish_br: ["Buscar videos de certificación en YouTube", "Búsqueda YouTube certificación"], 
      french: ["Rechercher vidéos certifiées YouTube", "Recherche certification YouTube"],
      german: ["YouTube‑Zertifizierung suchen", "Suche Zertifikationsvideos YouTube"],
      italian: ["Cerca video certificazione YouTube", "Ricerca certificazione YouTube"],
      chinese_tw: ["搜索YouTube認證影片", "YouTube認證搜索"],
      chinese_cn: ["搜索YouTube认证视频", "YouTube认证搜索"],
      chinese_sg: ["搜索YouTube认证视频", "YouTube认证搜索"],
      dutch_be: ["Zoek YouTube-certificeringsvideo's", "YouTube-certificering zoeken"],
      dutch_nl: ["Zoek YouTube-certificeringsvideo's", "YouTube-certificering zoeken"]
    }
  },
  "Change input source": {
      "Switch to USB": {
      english: ["Switch to USB"],
      portuguese: ["Mudar para USB"],
      spanish: ["Cambiar a USB"],
      spanish_ar: ["Cambiar a USB"],
      spanish_mx: ["Cambiar a USB"],
      spanish_cl: ["Cambiar a USB"],
      spanish_pe: ["Cambiar a USB"],
      spanish_br: ["Mudar para USB"],
      french: ["Basculer sur USB","Commuter sur USB","Va vers l'USB","Montre l'USB"],
      german: ["Schalte auf USB","USB Eingang"],
      italian: ["Passa a USB"],
      chinese_tw: ["切換到USB"],
      chinese_cn: ["切换到USB"],
      chinese_sg: ["切换到USB"],
      dutch_be: ["Schakel naar USB"],
      dutch_nl: ["Schakel naar USB"]
    },
    "Switch to HDMI 1": {
      english: ["Switch to HDMI 1"],
      portuguese: ["Mudar para HDMI 1"],
      spanish: ["Cambiar a HDMI 1"],
      spanish_ar: ["Cambiar a HDMI 1"],
      spanish_mx: ["Cambiar a HDMI 1"],
      spanish_cl: ["Cambiar a HDMI 1"],
      spanish_pe: ["Cambiar a HDMI 1"],
      spanish_br: ["Mudar para HDMI 1"],
      french: ["Basculer sur HDMI 1", "Commuter sur HDMI 1", "Va vers HDMI 1", "Montre HDMI 1"],
      german: ["Schalte auf HDMI 1", "HDMI 1 Eingang"],
      italian: ["Passa a HDMI 1"],
      chinese_tw: ["切換到HDMI 1"],
      chinese_cn: ["切换到HDMI 1"],
      chinese_sg: ["切换到HDMI 1"],
      dutch_be: ["Schakel naar HDMI 1"],
      dutch_nl: ["Schakel naar HDMI 1"]
    }
  },
  "Ambilight control": {
    "Turn On/Off Ambilight": {
      english: ["Turn on Ambilight", "Turn off Ambilight"],
      portuguese: ["Ligar Ambilight", "Desligar Ambilight"],
      spanish: ["Encender Ambilight", "Apagar Ambilight"],
      spanish_ar: ["Encender Ambilight", "Apagar Ambilight"],
      spanish_mx: ["Prender Ambilight", "Apagar Ambilight"],
      spanish_cl: ["Encender Ambilight", "Apagar Ambilight"],
      spanish_pe: ["Encender Ambilight", "Apagar Ambilight"],
      spanish_br: ["Encender Ambilight", "Apagar Ambilight"], 
      french: ["Activer Ambilight", "Désactiver Ambilight"],
      german: ["Ambilight einschalten", "Ambilight ausschalten"],
      italian: ["Attiva Ambilight", "Disattiva Ambilight"],
      chinese_tw: ["開啟Ambilight", "關閉Ambilight"],
      chinese_cn: ["开启Ambilight", "关闭Ambilight"],
      chinese_sg: ["开启Ambilight", "关闭Ambilight"],
      dutch_be: ["Ambilight aanzetten", "Ambilight uitzetten"],
      dutch_nl: ["Ambilight aanzetten", "Ambilight uitzetten"]
    }
  },
  "Launch": {
    "Go to info": {
      english: ["Go to info"],
      portuguese: ["Ir para informações"],
      spanish: ["Ir a información"],
      spanish_ar: ["Ir a información"],
      spanish_mx: ["Ir a información"],
      spanish_cl: ["Ir a información"],
      spanish_pe: ["Ir a información"],
      spanish_br: ["Ir a información"], 
      french: ["Aller à l'info"],
      german: ["Zu Infos"],
      italian: ["Vai a info"],
      chinese_tw: ["前往資訊"],
      chinese_cn: ["前往信息"],
      chinese_sg: ["前往信息"],
      dutch_be: ["Naar info"],
      dutch_nl: ["Naar info"]
    },
    "Launch TV guide": {
      english: ["Launch TV guide"],
      portuguese: ["Abrir guia de TV"],
      spanish: ["Abrir guía de TV"],
      spanish_ar: ["Abrir guía de TV"],
      spanish_mx: ["Abrir guía de TV"],
      spanish_cl: ["Abrir guía de TV"],
      spanish_pe: ["Abrir guía de TV"],
      spanish_br: ["Abrir guía de TV"], 
      french: ["Ouvrir le guide TV"],
      german: ["TV-Guide öffnen"],
      italian: ["Apri guida TV"],
      chinese_tw: ["啟動電視節目表"],
      chinese_cn: ["启动电视节目表"],
      chinese_sg: ["启动电视节目表"],
      dutch_be: ["TV-gids openen"],
      dutch_nl: ["TV-gids openen"]
    },
    "Launch info": {
      english: ["Launch info"],
      portuguese: ["Abrir informações"],
      spanish: ["Abrir información"],
      spanish_ar: ["Abrir información"],
      spanish_mx: ["Abrir información"],
      spanish_cl: ["Abrir información"],
      spanish_pe: ["Abrir información"],
      spanish_br: ["Abrir información"], 
      french: ["Lancer l'info"],
      german: ["Info öffnen"],
      italian: ["Avvia info"],
      chinese_tw: ["啟動資訊"],
      chinese_cn: ["启动信息"],
      chinese_sg: ["启动信息"],
      dutch_be: ["Info openen"],
      dutch_nl: ["Info openen"]
    },
    "Go to inputs": {
      english: ["Go to inputs"],
      portuguese: ["Ir para entradas"],
      spanish: ["Ir a entradas"],
      spanish_ar: ["Ir a entradas"],
      spanish_mx: ["Ir a entradas"],
      spanish_cl: ["Ir a entradas"],
      spanish_pe: ["Ir a entradas"],
      spanish_br: ["Ir a entradas"], 
      french: ["Aller aux entrées"],
      german: ["Zu Eingängen"],
      italian: ["Vai a ingressi"],
      chinese_tw: ["前往輸入"],
      chinese_cn: ["前往输入"],
      chinese_sg: ["前往输入"],
      dutch_be: ["Naar ingangen"],
      dutch_nl: ["Naar ingangen"]
    }
  }
};

module.exports = { tvControlData, translations };